const messages = {
  es: {
    translations: {
      appointments: {
        menu: {
          calendar: 'Calendario',
        },
        tooltip: {
          details: 'Detalles',
          busyHint: 'Horario ocupado por un evento de Google Calendar. Los detalles del evento no se muestran.',
        },
        grid: {
          title: 'Seleccione un horario',
          chooseType: 'Elija el tipo de atención para ver los horarios libres.',
          previousMonth: 'Mes anterior',
          nextMonth: 'Mes siguiente',
          previousWeek: 'Semana anterior',
          nextWeek: 'Semana siguiente',
          freeDaysHint: 'Los días destacados tienen horarios libres.',
          noWeekSlots: 'Ningún horario libre esta semana. Use las flechas o elija otro día del mes.',
          changeTime: 'Cambiar horario',
          sideBySide: 'Lado a lado',
        },
        phase6: {
          myAgenda: 'Mi agenda: {{name}}',
          connectedAs: 'Google conectado: {{email}}',
          clinicFallback: 'Sin Google propio; vale la agenda de la clínica.',
          connectOwnGoogle: 'Conectar mi Google',
          reconnectOwnGoogle: 'Reconectar mi Google',
          disconnectOwnGoogle: 'Desconectar Google propio',
          connectOwnGoogleHint: 'El propio profesional conecta su Google en su pantalla de Agenda.',
          myGoogleCalendar: 'Mi agenda de Google',
          disconnectTitle: 'Desconectar Google',
          disconnectMessage: 'Los eventos ya creados en Google permanecen allí. ¿Desconectar esta cuenta?',
          accessUser: 'Usuario de acceso',
          noAccessUser: 'Sin acceso propio',
          ownHours: 'Horario de trabajo propio',
          hoursHint: 'Sin horario propio, vale el horario de la clínica. Con horario propio, los días sin período quedan cerrados. En cada día, indique inicio y fin del primer período y, si es necesario, del segundo.',
          firstPeriod: 'Primer período',
          secondPeriod: 'Segundo período',
          start: 'inicio',
          end: 'fin',
          noClinicCalendar: 'Sin agenda de la clínica',
          changeProfessional: 'Cambiar profesional',
          saveChange: 'Guardar cambio',
          professionalChanged: 'Profesional cambiado.',
          professionalChangedTo: 'Profesional cambiado a {{name}}',
        },
        reports: {
          title: 'Informes de la Agenda',
          subtitle: 'Acompañe confirmaciones, ausencias, cancelaciones y el uso de la IA en el período elegido.',
          lastDays: 'Últimos {{days}} días',
          from: 'Desde',
          to: 'Hasta',
          invalidPeriod: 'Elija un período de 1 a 366 días.',
          note: 'Considera las citas que comienzan en el período.',
          total: 'Citas',
          confirmationRate: 'Tasa de confirmación',
          confirmedCount: '{{count}} confirmadas',
          noShowRate: 'Tasa de faltas',
          noShowHint: 'Entre las que ya tuvieron resultado',
          cancellations: 'Cancelaciones',
          reschedules: 'Reprogramaciones',
          byAi: '{{count}} por la IA',
          byStatus: 'Por estado',
          cancellationsByOrigin: 'Cancelaciones por origen',
          reschedulesByOrigin: 'Reprogramaciones por origen',
          byProfessional: 'Por profesional',
          byType: 'Por tipo de atención',
          clinicCalendar: 'Agenda de la clínica',
          noType: 'Sin tipo',
          aiUsage: 'Uso de la IA en el período',
          repliesRead: 'Respuestas leídas',
          modelCalls: 'Llamadas al modelo',
          tokens: 'Tokens',
          failures: 'Fallos',
          empty: 'Ningún registro en el período.',
          name: 'Nombre',
          attended: 'Asistieron',
          noShows: 'Faltas',
          cancelled: 'Cancelados',
          origins: {
            user: 'Agente',
            whatsapp: 'Cliente (WhatsApp)',
            ai: 'IA',
            google: 'Google Calendar',
            system: 'Sistema',
          },
        },
        notifications: {
          tab: 'Notificaciones',
          intro: 'El sistema avisa al cliente por WhatsApp, entiende la respuesta (confirmar, cancelar o reprogramar) y actualiza la cita.',
          connection: 'Conexión de WhatsApp para las notificaciones',
          off: 'Desactivadas',
          handoffQueue: 'Cola de las conversaciones entregadas a una persona',
          noQueue: 'Ninguna (mantiene la cola actual)',
          reminders: 'Recordatorios automáticos',
          daysBefore: '{{amount}} día(s) antes',
          hoursBefore: '{{amount}} hora(s) antes',
          minutesBefore: '{{amount}} minutos antes',
          messages: 'Mensajes',
          variables: 'Variables',
          variablesHint: 'Haga clic en una variable para copiarla y péguela en el texto del mensaje. Al enviar, se reemplaza por el dato de la cita.',
          variableCopied: '{{variable}} copiada.',
          copyFailed: 'No fue posible copiar. Seleccione y copie la variable manualmente.',
          copyVariable: 'Copiar {{variable}}',
          variableDescriptions: {
            nome: 'Nombre del contacto',
            data: 'Fecha de la cita',
            hora: 'Hora de la cita',
            tipo: 'Tipo de atención',
            empresa: 'Nombre de la empresa',
            opcoes: 'Lista numerada: horarios al reprogramar o citas para elegir',
          },
          restoreDefault: 'Restaurar predeterminado',
          sending: 'Envío',
          preview: 'Vista previa en WhatsApp',
          customized: 'Personalizada',
          groups: {
            request: 'Solicitudes de respuesta',
            replies: 'Respuestas al cliente',
            reschedule: 'Reprogramación con IA',
          },
          notifyOnCreate: 'Enviar confirmación por WhatsApp',
          notifyCustomer: 'Avisar al cliente por WhatsApp',
          sent: 'Enviado por WhatsApp: {{notification}}',
          sendFailed: 'No se pudo enviar por WhatsApp: {{notification}}',
          notes: {
            max_rounds: 'Entregado a un agente: no se aceptó ningún horario',
            no_slots: 'Entregado a un agente: sin horarios libres',
            handoff: 'Entregado a un agente',
            taken_over: 'Conversación asumida por un agente',
          },
          conversation: 'Conversación por WhatsApp',
          resend: 'Reenviar notificación',
          resent: 'Notificación enviada.',
          takeOver: 'Asumir conversación',
          tookOver: 'Conversación asumida.',
          kinds: {
            reschedulePreference: 'Reprogramar: pregunta del mejor día',
            rescheduleOptions: 'Reprogramar: horarios ofrecidos',
            rescheduleDone: 'Reprogramar: horario reprogramado',
            noSlots: 'Reprogramar: sin horarios libres',
            whichAppointment: 'Pregunta de qué cita',
            confirmationRequest: 'Solicitud de confirmación',
            reminder: 'Recordatorio',
            rescheduled: 'Aviso de nuevo horario',
            confirmed: 'Confirmación',
            cancelled: 'Aviso de cancelación',
            cancelQuestion: 'Pregunta de cancelación',
            cancelKept: 'Aviso de horario mantenido',
            unclear: 'Solicitud de repetir la respuesta',
            handoff: 'Aviso de atención humana',
          },
          stages: {
            reschedule_collect: 'Reprogramando con la IA: esperando el día preferido',
            reschedule_choose: 'Reprogramando con la IA: esperando la elección del horario',
            awaiting_reply: 'Esperando la respuesta del cliente',
            awaiting_cancel_confirmation: 'Esperando la confirmación de la cancelación',
            handed_off: 'Con un agente',
            done: 'Conversación completada',
            expired: 'Conversación cerrada sin respuesta',
          },
          intents: {
            confirm: 'Confirmar',
            cancel: 'Cancelar',
            reschedule: 'Reprogramar',
            question: 'Duda',
            handoff: 'Hablar con un agente',
            unclear: 'No entendida',
          },
          noReplies: 'El cliente aún no respondió.',
          readings: {
            number: 'Respuesta con el número de la opción',
            keyword: 'Identificada por palabra clave',
            ai: 'Interpretada por la IA',
            fallback: 'No se pudo entender',
          },
          sources: {
            number: 'Número',
            keyword: 'Palabra',
            ai: 'IA',
            fallback: 'No entendida',
          },
        },
        ai: {
          rescheduleEnable: 'Reprogramar con IA',
          rescheduleHint: 'Cuando el cliente pide reprogramar, el sistema pregunta el mejor día, ofrece horarios libres y completa el cambio. Sin esto, un agente asume.',
          searchDays: 'Buscar horarios en los próximos (días)',
          minNotice: 'Antelación mínima (horas)',
          optionsCount: 'Horarios ofrecidos por vez',
          maxRounds: 'Máximo de listas antes de llamar a un agente',
          tab: 'Respuestas e IA',
          intro: 'Las respuestas "1", "2" y "3" siempre se entienden. Con la IA activada, el sistema también entiende frases libres, como "sí, pero voy a llegar un poco tarde".',
          enable: 'Entender respuestas en texto libre con IA',
          notConfigured: 'La IA aún no está configurada en este entorno. Hable con el administrador del sistema.',
          debounce: 'Esperar mensajes seguidos (segundos)',
          debounceHint: 'Si el cliente envía más de un mensaje, el sistema espera este tiempo y lo lee todo como una sola respuesta.',
          testTitle: 'Probar interpretación',
          testHint: 'Escriba una respuesta de cliente y vea cómo la entendería el sistema. La prueba usa la IA aunque esté desactivada arriba.',
          customerReply: 'Respuesta del cliente',
          simulateCancelQuestion: 'Simular la respuesta a la pregunta "¿Confirma la cancelación?"',
          test: 'Probar',
          understood: 'Entendió',
          unreachable: 'No se pudo consultar la IA.',
          usageTitle: 'Consumo en los últimos 30 días',
          usageSummary: '{{replies}} respuestas leídas, {{calls}} consultas a la IA, {{tokens}} tokens, {{errors}} fallos.',
        },
        google: {
          tab: 'Google Calendar',
          intro: 'Opcional. Con una agenda de Google conectada, cada cita se convierte en un evento en ella y los eventos que ya están allí bloquean el horario en el sistema.',
          notConfigured: 'La integración con Google Calendar aún no está configurada en este entorno. Hable con el administrador del sistema.',
          revokedHint: 'Las nuevas citas se siguen creando y se enviarán a Google después de reconectar.',
          connect: 'Conectar con Google',
          reconnect: 'Reconectar con Google',
          connectedToast: 'Cuenta de Google conectada. Elija la agenda que se usará.',
          connectErrorToast: 'No se pudo conectar con Google. Inténtelo de nuevo.',
          connectedAs: 'Conectado como',
          calendar: 'Agenda',
          lastSync: 'Última sincronización',
          syncNow: 'Sincronizar ahora',
          synced: 'Sincronización completada.',
          changeCalendar: 'Cambiar de agenda',
          disconnect: 'Desconectar',
          disconnected: 'Google Calendar desconectado.',
          disconnectTitle: 'Desconectar Google Calendar',
          disconnectMessage: 'Las citas siguen en el sistema y los eventos ya creados en Google no se eliminan. Los horarios ocupados importados dejan de bloquear la agenda.',
          calendarLabel: 'Agenda de Google',
          primary: 'principal',
          noCalendars: 'No se encontró ninguna agenda con permiso de edición en esta cuenta.',
          syncExisting: 'Enviar a Google las citas futuras que ya existen',
          useCalendar: 'Usar esta agenda',
          calendarConnected: 'Agenda de Google conectada.',
          busy: 'Ocupado (Google Calendar)',
          fieldShare: 'Enviar a la descripción de Google Calendar',
          fieldShareHint: 'El valor de este campo aparece en la descripción del evento. Evite datos sensibles.',
          blockAllDay: 'Los eventos de todo el día de Google bloquean el horario',
          syncStatus: {
            synced: 'Sincronizado con Google Calendar',
            pending: 'Enviando a Google Calendar…',
            error: 'No se pudo sincronizar con Google Calendar',
            retry: 'Reintentar',
          },
        },
        title: 'Agenda',
        minutes: '{{minutes}} min',
        yes: 'Sí',
        buttons: {
          reports: 'Informes',
          add: 'Nueva cita',
          create: 'Agregar',
          settings: 'Configuración',
          schedule: 'Agendar',
          cancel: 'Cancelar',
          back: 'Volver',
          confirm: 'Confirmar',
          reschedule: 'Reprogramar',
          attended: 'Asistió',
          noShow: 'No asistió',
          cancelAppointment: 'Cancelar cita',
          reactivate: 'Reactivar',
          save: 'Guardar',
        },
        filters: {
          professional: 'Profesional',
          allProfessionals: 'Todos los profesionales',
          status: 'Estado',
          allStatuses: 'Todos los estados',
          allTypes: 'Todos los tipos',
        },
        status: {
          pending_confirmation: 'Esperando confirmación',
          confirmed: 'Confirmado',
          reschedule_requested: 'Reprogramación solicitada',
          cancelled: 'Cancelado',
          completed: 'Asistió',
          no_show: 'No asistió',
        },
        origin: {
          user: 'Usuario',
          whatsapp: 'Cliente (WhatsApp)',
          ai: 'IA',
          google: 'Google Calendar',
          system: 'Sistema',
        },
        calendar: {
          date: 'Fecha',
          time: 'Hora',
          event: 'Cita',
          allDay: 'Todo el día',
          week: 'Semana',
          day: 'Día',
          month: 'Mes',
          previous: 'Anterior',
          next: 'Siguiente',
          today: 'Hoy',
          agenda: 'Lista',
          noEvents: 'No hay citas en este período.',
        },
        contact: {
          title: 'Agenda',
          upcoming: 'Hoy y próximas',
          upcomingTitle: 'Próximas citas',
          history: 'Historial de los últimos 90 días',
          historyEmpty: 'No hay otras citas en los últimos 90 días.',
          empty: 'Este contacto no tiene citas programadas.',
          schedule: 'Agendar',
          newAppointment: 'Nueva cita',
          nextAppointment: 'Próxima cita: {{when}}',
          loadHistory: 'Cargar historial',
          hideHistory: 'Ocultar historial',
          today: 'Hoy',
          tomorrow: 'Mañana',
          yesterday: 'Ayer',
          close: 'Cerrar',
        },
        modal: {
          addTitle: 'Nueva cita',
        },
        form: {
          professional: 'Profesional',
          selectProfessional: 'Seleccione el profesional',
          contact: 'Contacto',
          contactHelp: 'Escriba al menos 3 letras para buscar',
          contactPrefilled: 'Completado a partir de la conversación. Puede cambiarlo si es necesario.',
          addContact: 'Agregar',
          type: 'Tipo de atención',
          date: 'Fecha',
          time: 'Horario',
          noSlots: 'No hay horarios libres este día. Revise el horario de atención de la empresa o elija otra fecha.',
          notes: 'Observaciones',
        },
        reschedule: {
          title: 'Reprogramar',
          hint: 'Después de reprogramar, la cita vuelve a "Esperando confirmación".',
        },
        reactivate: {
          title: 'Reactivar cita',
          hint: 'La cita vuelve en el mismo horario, esperando la confirmación del cliente. Para otro horario, reactívela y luego reprograme.',
          note: 'Motivo (opcional)',
          notify: 'Pedir la confirmación al cliente por WhatsApp',
        },
        cancel: {
          title: 'Cancelar cita',
          reason: 'Motivo (opcional)',
        },
        drawer: {
          professional: 'Profesional',
          status: 'Estado',
          dateTime: 'Fecha y hora',
          scheduledBy: 'Agendado por',
          cancelReason: 'Motivo de la cancelación',
          history: 'Historial',
          rescheduledFromTo: 'Reprogramado de {{from}} a {{to}}',
        },
        toasts: {
          created: 'Cita creada con éxito.',
          rescheduled: 'Cita reprogramada con éxito.',
          cancelled: 'Cita cancelada.',
          statusUpdated: 'Estado actualizado.',
          reactivated: 'Cita reactivada.',
        },
        settings: {
          professionals: {
            intro: 'Opcional. Registre a los profesionales que atienden para que cada uno tenga su propia agenda. Con algún profesional activo, toda cita necesita un profesional.',
            add: 'Nuevo profesional',
            empty: 'Ningún profesional registrado. La agenda sigue siendo única, sin elegir un profesional.',
            name: 'Nombre',
            googleCalendar: 'Agenda de Google',
            googleHelp: 'Sin agenda propia, las citas usan la agenda de la clínica cuando está disponible.',
            noGoogleCalendar: 'Usar agenda de la clínica',
            systemOnly: 'Agenda de la clínica o solo en el sistema',
            addTitle: 'Nuevo profesional',
            editTitle: 'Editar profesional',
            deleteTitle: 'Eliminar profesional',
            deleteMessage: '¿Desea eliminar al profesional "{{name}}"? Los profesionales con citas no se pueden eliminar; desactívelos.',
            deleted: 'Profesional eliminado correctamente.',
            saved: 'Profesional guardado correctamente.',
          },
          title: 'Configuración de la Agenda',
          subtitle: 'Defina cómo funciona la agenda: tipos de atención, profesionales, campos, integraciones, notificaciones y reglas.',
          active: 'Activo',
          inactive: 'Inactivo',
          actions: 'Acciones',
          tabs: {
            professionals: 'Profesionales',
            types: 'Tipos de atención',
            fields: 'Campos',
            rules: 'Reglas',
          },
          types: {
            intro: 'Defina los tipos de atención, como consulta, retorno o evaluación, y la duración de cada uno.',
            add: 'Nuevo tipo',
            empty: 'No hay tipos de atención registrados. Cree al menos uno para poder agendar.',
            name: 'Nombre',
            duration: 'Duración (minutos)',
            durationShort: 'Duración',
            durationOptions: {
              minutes: '{{minutes}} minutos',
              hour: '1 hora',
              hours: '{{hours}} horas',
              hoursMinutes: '{{hours}}h{{minutes}}',
              custom: 'Personalizado',
              customHelp: 'Informe de 5 a 480 minutos.',
            },
            color: 'Color',
            addTitle: 'Nuevo tipo de atención',
            editTitle: 'Editar tipo de atención',
            deleteTitle: 'Eliminar tipo de atención',
            deleteMessage: '¿Eliminar el tipo "{{name}}"? Los tipos ya usados en citas no se pueden eliminar; desactívelos.',
            saved: 'Tipo de atención guardado con éxito.',
            deleted: 'Tipo de atención eliminado con éxito.',
          },
          fields: {
            intro: 'Además del contacto, estos campos se completan en cada cita. Use las flechas para cambiar el orden.',
            add: 'Nuevo campo',
            empty: 'No hay campos adicionales registrados.',
            label: 'Nombre del campo',
            type: 'Tipo',
            options: 'Opciones (una por línea)',
            required: 'Obligatorio',
            addTitle: 'Nuevo campo',
            editTitle: 'Editar campo',
            deleteTitle: 'Eliminar campo',
            deleteMessage: '¿Eliminar el campo "{{name}}"? Las citas ya creadas conservan el valor completado.',
            saved: 'Campo guardado con éxito.',
            deleted: 'Campo eliminado con éxito.',
            moveUp: 'Mover hacia arriba',
            moveDown: 'Mover hacia abajo',
            types: {
              text: 'Texto corto',
              textarea: 'Texto largo',
              number: 'Número',
              date: 'Fecha',
              select: 'Lista de opciones',
              checkbox: 'Casilla de verificación',
            },
          },
          rules: {
            slotInterval: 'Intervalo entre horarios (minutos)',
            defaultDuration: 'Duración predeterminada de los nuevos tipos (minutos)',
            hint: 'Los horarios libres siguen el horario de atención de la empresa, configurado en Configuración.',
            saved: 'Configuración guardada con éxito.',
          },
        },
      },
      backendErrors: {
        ERR_APPOINTMENT_NOTIFICATIONS_DISABLED: 'Elija primero una conexión de WhatsApp en la configuración de notificaciones.',
        ERR_APPOINTMENT_NOTIFICATION_FAILED: 'WhatsApp no pudo enviar la notificación. Revise la conexión.',
        ERR_APPOINTMENT_NO_ACTIVE_CONVERSATION: 'No hay una conversación abierta con el cliente.',
        ERR_APPOINTMENT_TEMPLATE_INVALID: 'Uno de los mensajes es inválido o demasiado largo.',
        ERR_APPOINTMENT_AI_NOT_CONFIGURED: 'La IA no está configurada en este entorno.',
        ERR_APPOINTMENT_AI_FAILED: 'No se pudo acceder a la IA.',
        ERR_GOOGLE_CALENDAR_NOT_CONFIGURED: 'La integración con Google Calendar no está configurada.',
        ERR_GOOGLE_CALENDAR_NOT_CONNECTED: 'Google Calendar no está conectado.',
        ERR_GOOGLE_CALENDAR_ACCESS_REVOKED: 'El acceso a Google fue revocado o venció. Reconecte para seguir sincronizando.',
        ERR_GOOGLE_CALENDAR_NOT_FOUND: 'Agenda no encontrada o sin permiso de edición.',
        ERR_GOOGLE_CALENDAR_INVALID_STATE: 'El enlace de conexión venció. Inténtelo de nuevo.',
        ERR_GOOGLE_CALENDAR_NO_REFRESH_TOKEN: 'Google no concedió acceso sin conexión. Inténtelo de nuevo.',
        ERR_GOOGLE_CALENDAR_SCOPES_MISSING: 'Conceda todos los permisos solicitados para conectar.',
        ERR_GOOGLE_CALENDAR_SYNC_FAILED: 'No se pudo acceder a Google Calendar. Inténtelo de nuevo.',
        ERR_GOOGLE_EVENT_REMOVED: 'El evento fue eliminado en Google Calendar. Reintente para crearlo de nuevo.',
        ERR_APPOINTMENT_CALENDAR_BLOCKED: 'Este horario está ocupado en Google Calendar. Elija otro horario.',
        ERR_NO_CONTACT_FOUND: 'Contacto no encontrado.',
        ERR_APPOINTMENT_NOT_FOUND: 'Cita no encontrada.',
        ERR_APPOINTMENT_TYPE_NOT_FOUND: 'Tipo de atención no encontrado o inactivo.',
        ERR_APPOINTMENT_FIELD_NOT_FOUND: 'Campo no encontrado.',
        ERR_APPOINTMENT_TIME_CONFLICT: 'Este horario ya está ocupado. Elija otro horario.',
        ERR_APPOINTMENT_CLOSED: 'Esta cita ya está cerrada y no se puede modificar.',
        ERR_APPOINTMENT_NOT_CANCELLED: 'Solo una cita cancelada puede reactivarse.',
        ERR_APPOINTMENT_REACTIVATE_PAST: 'El horario de esta cita ya pasó. Cree una nueva cita.',
        ERR_APPOINTMENT_TYPE_IN_USE: 'Este tipo se usa en citas y no se puede eliminar. Desactívelo.',
        ERR_APPOINTMENT_PROFESSIONAL_NOT_LINKED: 'Su usuario no está vinculado a un profesional.',
        ERR_APPOINTMENT_PROFESSIONAL_USER_NOT_FOUND: 'Usuario de acceso no encontrado en esta empresa.',
        ERR_APPOINTMENT_PROFESSIONAL_USER_IN_USE: 'Este usuario ya está vinculado a otro profesional.',
        ERR_APPOINTMENT_PROFESSIONAL_INVALID_SCHEDULE: 'Revise los horarios de trabajo del profesional.',
        ERR_APPOINTMENT_PROFESSIONAL_UNCHANGED: 'La cita ya está asignada a ese profesional.',
        ERR_APPOINTMENT_PROFESSIONAL_NOT_FOUND: 'Profesional no encontrado o inactivo.',
        ERR_APPOINTMENT_PROFESSIONAL_REQUIRED: 'Elija el profesional de la cita.',
        ERR_APPOINTMENT_PROFESSIONAL_IN_USE: 'Este profesional tiene citas y no se puede eliminar. Desactívelo.',
        ERR_APPOINTMENT_IN_THE_PAST: 'Elija una fecha y hora futuras.',
        ERR_APPOINTMENT_INVALID_DATE: 'Fecha inválida.',
        ERR_APPOINTMENT_INVALID_RANGE: 'Rango de fechas inválido.',
        ERR_APPOINTMENT_RANGE_TOO_LARGE: 'El rango de fechas es demasiado grande.',
        ERR_APPOINTMENT_FIELD_REQUIRED: 'Complete todos los campos obligatorios.',
        ERR_APPOINTMENT_FIELD_INVALID: 'Uno de los campos tiene un valor inválido.',
        ERR_APPOINTMENT_FIELD_OPTIONS_REQUIRED: 'Agregue al menos una opción a la lista.',
      },
      signup: {
        title: 'Registrarse',
        toasts: {
          success: '¡Usuario creado exitosamente! ¡Inicie sesión!',
          fail: 'Error al crear usuario. Verifique los datos ingresados.',
        },
        form: {
          name: 'Nombre',
          email: 'Correo electrónico',
          password: 'Contraseña',
        },
        buttons: {
          submit: 'Registrarse',
          login: '¿Ya tienes una cuenta? ¡Inicia sesión!',
        },
      },
      login: {
        title: 'Iniciar sesión',
        form: {
          email: 'Correo electrónico',
          password: 'Contraseña',
        },
        buttons: {
          submit: 'Iniciar sesión',
          register: ' ¡Crea tu cuenta en solo unos clics!',
        },
      },
      plans: {
        form: {
          name: 'Nombre',
          users: 'Usuarios',
          connections: 'Conexiones',
          campaigns: 'Campañas',
          schedules: 'Programaciones',
          crm: 'CRM',
          enabled: 'Habilitadas',
          disabled: 'Deshabilitadas',
          clear: 'Cancelar',
          delete: 'Eliminar',
          save: 'Guardar',
          yes: 'Sí',
          no: 'No',
          money: 'R$',
        },
      },
      companies: {
        title: 'Registrar Empresa',
        form: {
          name: 'Nombre de la Empresa',
          plan: 'Plan',
          token: 'Token',
          submit: 'Registrar',
          success: '¡Empresa creada exitosamente!',
        },
      },
      auth: {
        toasts: {
          success: '¡Inicio de sesión exitoso!',
        },
        token: 'Token',
      },
      dashboard: {
        charts: {
          ticketsCreated: 'Tickets creados: ',
          tickets: 'Tickets',
          perDay: {
            title: 'Atenciones de hoy: ',
          },
        },
        filters: {
          dateFrom: 'Fecha inicial',
          dateTo: 'Fecha final',
          period: 'Periodo',
          noneSelected: 'Ninguno seleccionado',
          last3Days: 'Ultimos 3 dias',
          last7Days: 'Ultimos 7 dias',
          last15Days: 'Ultimos 15 dias',
          last30Days: 'Ultimos 30 dias',
          last60Days: 'Ultimos 60 dias',
          last90Days: 'Ultimos 90 dias',
          filterType: 'Tipo de filtro',
          dateFilter: 'Filtro por fecha',
          periodFilter: 'Filtro por periodo',
          filter: 'Filtrar',
        },
        cards: {
          activeConnections: 'Conexiones activas',
          companies: 'Empresas',
          inConversation: 'En conversacion',
          waiting: 'Esperando',
          newContacts: 'Nuevos contactos',
          avgConversationTime: 'T.M. de conversacion',
          finished: 'Finalizados',
          avgWaitTime: 'T.M. de espera',
        },
        messages: {
          parameterizeFilter: 'Parametriza el filtro',
        },
        awaitingResponse: {
          title: 'Tickets sin respuesta',
          subtitle: 'Backlog actual con la última respuesta del contacto dentro del período filtrado.',
          chartTitle: 'Evolución diaria de tickets sin respuesta',
          open: 'Open',
          pending: 'Pending',
          empty: 'No se encontraron tickets sin respuesta para el período seleccionado.',
        },
        userRatings: {
          title: 'Atenciones evaluadas - {{name}}',
          subtitle: 'Evaluaciones recibidas en el período filtrado en el dashboard.',
          openRatings: 'Ver atenciones evaluadas',
          contact: 'Contacto',
          queue: 'Cola',
          rate: 'Nota',
          ratedAt: 'Evaluado el',
          viewMessages: 'Ver mensajes',
          empty: 'No hay atenciones evaluadas en el período filtrado.',
          noQueue: 'Sin cola',
          close: 'Cerrar',
        },
      },
      connections: {
        title: 'Conexiones',
        toasts: {
          deleted: '¡Conexión con WhatsApp eliminada exitosamente!',
          disconnected: 'Sesión de WhatsApp desconectada exitosamente.',
          connecting: 'Iniciando sesión de WhatsApp. Espera el código QR.',
          requestingQr: 'Solicitando un nuevo código QR. Espera la actualización.',
        },
        confirmationModal: {
          deleteTitle: 'Eliminar',
          deleteMessage: '¿Estás seguro? Esta acción no se puede deshacer.',
          disconnectTitle: 'Desconectar',
          disconnectMessage: '¿Estás seguro? Deberás volver a leer el código QR.',
        },
        buttons: {
          add: 'Agregar WhatsApp',
          disconnect: 'desconectar',
          tryAgain: 'Intentar de nuevo',
          qrcode: 'CÓDIGO QR',
          newQr: 'Nuevo CÓDIGO QR',
          pairingCode: 'Código',
          connecting: 'Conectando',
          restart: 'Reiniciar',
        },
        toolTips: {
          disconnected: {
            title: 'Error al iniciar sesión en WhatsApp',
            content: 'Asegúrate de que tu teléfono esté conectado a internet e inténtalo nuevamente, o solicita un nuevo código QR',
          },
          qrcode: {
            title: 'Esperando lectura del código QR',
            content: "Haz clic en el botón 'CÓDIGO QR' y lee el código QR con tu teléfono para iniciar sesión",
          },
          connected: {
            title: '¡Conexión establecida!',
          },
          timeout: {
            title: 'Se perdió la conexión con el teléfono',
            content: "Asegúrate de que tu teléfono esté conectado a internet y WhatsApp esté abierto, o haz clic en el botón 'Desconectar' para obtener un nuevo código QR",
          },
        },
        table: {
          name: 'Nombre',
          status: 'Estado',
          lastUpdate: 'Última actualización',
          default: 'Predeterminado',
          actions: 'Acciones',
          session: 'Sesión',
        },
        whatsappModal: {
          title: {
            add: 'Agregar WhatsApp',
            edit: 'Editar WhatsApp',
          },
          tabs: {
            general: 'General',
            messages: 'Mensajes',
            assessments: 'Evaluaciones',
            integrations: 'Integraciones',
            schedules: 'Horario de expediente',
          },
          form: {
            name: 'Nombre',
            default: 'Predeterminado',
            sendIdQueue: 'Fila',
            timeSendQueue: 'Redireccionar a cola en X minutos',
            queueRedirection: 'Redirección de cola',
            outOfHoursMessage: 'Mensaje de fuera de expediente',
            queueRedirectionDesc: 'Seleccione una fila para redirigir los contactos que no tienen cola',
            agent: 'Agente',
            noAgent: 'Sin agente',
            agentTestModeHint: 'Este agente está en modo de prueba. Solo los teléfonos de la whitelist usarán el agente; los demás seguirán el flujo normal del chatbot por colas.',
            agentLiveModeHint: 'Este agente está liberado para toda la conexión. Mientras esté vinculado aquí, responderá antes del flujo normal del chatbot.',
            expiresTicket: 'Cerrar chats abiertos después de X minutos',
            expiresInactiveMessage: 'Mensaje de cierre por inactividad',
            greetingMessage: 'Mensaje de saludo',
            complationMessage: 'Mensaje de conclusión',
          },
          buttons: {
            okAdd: 'Agregar',
            okEdit: 'Guardar',
            cancel: 'Cancelar',
            generateApiToken: 'Generar Token API',
          },
          success: 'WhatsApp guardado con éxito.',
          toasts: {
            tokenCopied: 'Token copiado al portapapeles!',
            variableCopied: 'Variable copiada al portapapeles!',
          },
        },
        qrCode: {
          message: 'Lea el código QR para iniciar sesión',
        },
        qrCodeModal: {
          title: 'QrCode',
          connectTitle: 'Conectar a WhatsApp Web',
          waiting: 'Esperando la generación del código QR...',
          loadingQr: 'Cargando código QR...',
          emptyTitle: 'El código QR aún no fue generado',
          emptyHelper: 'Inicie una nueva generación para conectar con la cámara de WhatsApp.',
          generateQrButton: 'Generar código QR',
          refreshesIn: 'Se actualiza en:',
          expiresSoon: 'El código QR caduca pronto.',
          tabs: {
            qrCode: 'Código QR',
            pairingCode: 'Código',
          },
          qrInstructions: {
            openWhatsApp: 'Abra WhatsApp en el celular',
            openSettings: 'Vaya a Menú o Configuración',
            linkedDevices: 'Seleccione Dispositivos vinculados',
            scanQrCode: 'Apunte la cámara al código QR',
          },
          pairing: {
            countryCodeLabel: 'País',
            phoneLabel: 'Número de WhatsApp',
            phonePlaceholder: '5512345678',
            phoneHelper: 'Ingrese área y número. Use solo dígitos.',
            invalidPhone: 'Ingrese un número válido con código de país y solo dígitos.',
            generateButton: 'Generar código',
            codeHelper: 'En el celular, elija vincular con número de teléfono e ingrese este código.',
            instructions: {
              openWhatsApp: 'Abra WhatsApp en el celular',
              linkDevice: 'Vaya a Dispositivos vinculados y toque Vincular un dispositivo',
              enterCode: 'Elija vincular con número de teléfono e ingrese el código generado',
            },
          },
        },
        contacts: {
          title: 'Contactos',
          toasts: {
            deleted: 'Contacto eliminado con éxito!',
            deletedAll: 'Todos los contactos eliminados con éxito!',
          },
          searchPlaceholder: 'Buscar...',
          confirmationModal: {
            deleteTitle: 'Eliminar ',
            deleteAllTitle: 'Eliminar Todos',
            importTitle: 'Importar contactos',
            deleteMessage: '¿Seguro que desea eliminar este contacto? Se perderán todos los tickets relacionados.',
            deleteAllMessage: '¿Seguro que desea eliminar todos los contactos? Se perderán todos los tickets relacionados.',
            importMessage: '¿Desea importar todos los contactos del teléfono?',
          },
          buttons: {
            import: 'Importar Contactos',
            add: 'Agregar Contacto',
            export: 'Exportar Contactos',
            delete: 'Eliminar Todos Contactos',
          },
          table: {
            name: 'Nombre',
            whatsapp: 'WhatsApp',
            email: 'Correo electrónico',
            actions: 'Acciones',
          },
        },
        queueIntegrationModal: {
          title: {
            add: 'Agregar proyecto',
            edit: 'Editar proyecto',
          },
          form: {
            id: 'ID',
            type: 'Tipo',
            name: 'Nombre',
            projectName: 'Nombre del Proyecto',
            language: 'Lenguaje',
            jsonContent: 'JsonContent',
            urlN8N: 'URL',
            typebotSlug: 'Typebot - Slug',
            typebotExpires: 'Tiempo en minutos para expirar una conversación',
            typebotKeywordFinish: 'Palabra para finalizar el ticket',
            typebotKeywordRestart: 'Palabra para reiniciar el flujo',
            typebotRestartMessage: 'Mensaje al reiniciar la conversación',
            typebotUnknownMessage: 'Mensaje de opción inválida',
            typebotDelayMessage: 'Intervalo (ms) entre mensajes',
          },
          buttons: {
            okAdd: 'Agregar',
            okEdit: 'Guardar',
            cancel: 'Cancelar',
            test: 'Probar Bot',
          },
          messages: {
            testSuccess: 'Integración probada con éxito!',
            addSuccess: 'Integración agregada con éxito.',
            editSuccess: 'Integración editada con éxito.',
          },
        },
        sideMenu: {
          name: 'Menú Lateral Inicial',
          note: 'Si está habilitado, el menú lateral se iniciará cerrado',
          options: {
            enabled: 'Abierto',
            disabled: 'Cerrado',
          },
        },
        promptModal: {
          form: {
            name: 'Nombre',
            prompt: 'Prompt',
            testNumbers: 'Teléfonos habilitados para prueba',
            testNumbersPlaceholder: 'Ej.: 5511999999999, 5511888888888',
            testNumbersHelp: 'Separe los teléfonos con comas. Cuando esté completo, solo esos números entrarán en el flujo real del prompt.',
            fallbackQueue: 'Cola predeterminada cuando el agente no sepa responder',
            transferQueues: 'Colas a las que el agente puede transferir por tema',
            voice: 'Voz',
            max_tokens: 'Máximo de Tokens en la respuesta',
            temperature: 'Temperatura',
            apikey: 'API Key',
            max_messages: 'Máximo de mensajes en el Historial',
            voiceKey: 'Clave de la API de Voz',
            voiceRegion: 'Región de Voz',
          },
          success: 'Prompt guardado con éxito!',
          title: {
            add: 'Agregar Agente',
            edit: 'Editar Agente',
          },
          buttons: {
            okAdd: 'Agregar',
            okEdit: 'Guardar',
            cancel: 'Cancelar',
          },
        },
        prompts: {
          title: 'Agente',
          table: {
            name: 'Nombre',
            queue: 'Sector/Cola',
            max_tokens: 'Máximo Tokens Respuesta',
            actions: 'Acciones',
          },
          confirmationModal: {
            deleteTitle: 'Eliminar',
            deleteMessage: '¿Está seguro? ¡Esta acción no se puede deshacer!',
          },
          buttons: {
            add: 'Agregar Agente',
            test: 'Probar agente',
            edit: 'Editar agente',
            delete: 'Eliminar agente',
          },
          testChat: {
            title: 'Prueba del agente',
            modalTitle: 'Simulador del agente',
            topline: 'Entorno de validación',
            queueLabel: 'Cola de transferencia',
            emptyTitle: 'Elija un prompt para probar',
            emptyDescription: 'Use la acción de prueba en la tabla para abrir una conversación simulada con el agente.',
            startTitle: 'Conversación lista para prueba',
            startDescription: 'Envíe un mensaje y el backend responderá usando el prompt y la configuración guardados.',
            emptyConversation: 'Todavía no hay mensajes en esta simulación. Envíe la primera consulta para validar el comportamiento del agente.',
            inputLabel: 'Su mensaje',
            inputPlaceholder: 'Ej.: Quiero cancelar mi pedido y hablar con un agente humano.',
            send: 'Enviar',
            close: 'Cerrar',
            clear: 'Limpiar conversación',
            historyHint: 'Esta prueba usa hasta {{count}} mensajes del historial simulado del agente.',
            footerHint: 'Las respuestas aquí no crean tickets ni transfieren ninguna conversación real.',
            you: 'Usted',
            agent: 'Agente',
            transferBadge: 'Transferencia sugerida',
          },
        },
        contactModal: {
          title: {
            add: 'Agregar contacto',
            edit: 'Editar contacto',
          },
          form: {
            mainInfo: 'Datos del contacto',
            extraInfo: 'Información adicional',
            name: 'Nombre',
            number: 'Número de Whatsapp',
            birthday: 'Cumpleaños',
            email: 'Email',
            extraName: 'Nombre del campo',
            extraValue: 'Valor',
            whatsapp: 'Conexión Origen: ',
            leadSource: {
              label: 'Origen del lead',
              unset: 'Definir origen del lead',
              instagram: 'Instagram',
              facebook: 'Facebook',
              google_ads: 'Google Ads',
              youtube: 'YouTube',
              ai: 'IA (ChatGPT/otras)',
              whatsapp: 'WhatsApp directo',
              referral: 'Referido',
              site: 'Sitio web',
              other: 'Otro',
            },
          },
          buttons: {
            addExtraInfo: 'Agregar información',
            okAdd: 'Agregar',
            okEdit: 'Guardar',
            cancel: 'Cancelar',
          },
          success: 'Contacto guardado con éxito.',
        },
        queueModal: {
          title: {
            add: 'Agregar cola',
            edit: 'Editar cola',
          },
          form: {
            name: 'Nombre',
            color: 'Color',
            greetingMessage: 'Mensaje de saludo',
            complationMessage: 'Mensaje de conclusión',
            outOfHoursMessage: 'Mensaje de fuera de horario',
            ratingMessage: 'Mensaje de evaluación',
            token: 'Token',
            orderQueue: 'Orden de la cola (Bot)',
            integrationId: 'Integración',
            tagsToAdd: 'Tags para añadir',
            tagsToRemove: 'Tags para remover',
          },
          buttons: {
            okAdd: 'Agregar',
            okEdit: 'Guardar',
            cancel: 'Cancelar',
          },
        },
        userModal: {
          title: {
            add: 'Agregar usuario',
            edit: 'Editar usuario',
          },
          form: {
            name: 'Nombre',
            email: 'Email',
            password: 'Contraseña',
            cpf: 'CPF',
            profile: 'Perfil',
            whatsapp: 'Conexión Predeterminada',
            whatsapps: 'Conexiones permitidas',
            whatsappsHelper: 'Déjelo vacío para permitir todas las conexiones',

            allTicket: 'Ticket Sin Cola [Invisible]',
            allTicketEnabled: 'Habilitado',
            allTicketDesabled: 'Deshabilitado',
            viewAllTickets: 'Ver Todos los Tickets de la Cola',
            viewAllTicketsEnabled: 'Habilitado',
            viewAllTicketsDesabled: 'Deshabilitado',
          },
          buttons: {
            okAdd: 'Agregar',
            okEdit: 'Guardar',
            cancel: 'Cancelar',
          },
          success: 'Usuario guardado con éxito.',
        },
        scheduleModal: {
          title: {
            add: 'Nuevo Agendamiento',
            edit: 'Editar Agendamiento',
          },
          form: {
            body: 'Mensaje',
            contact: 'Contacto',
            sendAt: 'Fecha de Agendamiento',
            sentAt: 'Fecha de Envío',
          },
          buttons: {
            okAdd: 'Agregar',
            okEdit: 'Guardar',
            cancel: 'Cancelar',
          },
          success: 'Agendamiento guardado con éxito.',
          recurringEditInfo: 'Este agendamiento es recurrente. Los cambios solo afectarán a los próximos envíos.',
          recurringEditSingleInfo: 'Este agendamiento pertenece a una serie. Los cambios se aplicarán solo a él. Para alterar todos, edite el agendamiento principal.',
        },
        tagModal: {
          title: {
            add: 'Nueva Etiqueta',
            edit: 'Editar Etiqueta',
          },
          form: {
            name: 'Nombre',
            color: 'Color',
          },
          buttons: {
            okAdd: 'Agregar',
            okEdit: 'Guardar',
            cancel: 'Cancelar',
          },
          success: 'Etiqueta guardada con éxito.',
        },
        chat: {
          noTicketMessage: 'Seleccione un ticket para comenzar a conversar.',
        },
        uploads: {
          titles: {
            titleUploadMsgDragDrop: 'ARRASTRE Y SUELTE ARCHIVOS EN EL CAMPO ABAJO',
            titleFileList: 'Lista de archivo(s)',
          },
        },
        ticketsManager: {
          buttons: {
            newTicket: 'Nuevo',
          },
        },
        ticketsQueueSelect: {
          placeholder: 'Colas',
        },
        ticketsWhatsappSelect: {
          placeholder: 'Conexiones',
        },
        tickets: {
          toasts: {
            deleted: 'La atención en la que estaba ha sido eliminada.',
          },
          notification: {
            message: 'Mensaje de',
          },
          tabs: {
            open: { title: 'Abiertas' },
            closed: { title: 'Resueltos' },
            search: { title: 'Búsqueda' },
          },
          search: {
            placeholder: 'Buscar atención y mensajes',
          },
          buttons: {
            showAll: 'Todos',
          },
        },
        transferTicketModal: {
          title: 'Transferir Ticket',
          fieldLabel: 'Escribe para buscar usuarios',
          fieldQueueLabel: 'Transferir a cola',
          fieldQueuePlaceholder: 'Seleccione una cola',
          noOptions: 'No se encontraron usuarios con ese nombre',
          buttons: {
            ok: 'Transferir',
            cancel: 'Cancelar',
          },
        },
        ticketsList: {
          pendingHeader: 'Pendiente',
          assignedHeader: 'Atendiendo',
          awaitingResponseToggle: 'Esperando respuesta',
          noTicketsTitle: '¡Nada aquí!',
          noTicketsMessage: 'No se encontraron tickets con este estado o término de búsqueda',
          noAwaitingResponseTitle: 'No hay tickets esperando respuesta',
          noAwaitingResponseMessage: 'Ningún ticket abierto tiene actualmente la última respuesta del contacto pendiente de atención.',
          sort: {
            newestFirst: 'Más recientes primero. Haz clic para mostrar las conversaciones más antiguas.',
            oldestFirst: 'Más antiguas primero. Haz clic para mostrar las conversaciones más recientes.',
          },
          buttons: {
            accept: 'Aceptar',
            closed: 'Finalizar',
            reopen: 'Reabrir',
          },
          pendingEvaluationTag: 'Pendiente de evaluación',
          pendingEvaluationModal: {
            title: 'Ticket esperando evaluación',
            message: 'Si finalizas ahora, la evaluación puede no contabilizarse y esta acción puede ir en contra de las directrices de la empresa. ¿Deseas finalizar de todos modos?',
          },
        },
        newTicketModal: {
          title: 'Crear Ticket',
          fieldLabel: 'Escribe para buscar el contacto',
          add: 'Agregar',
          buttons: {
            ok: 'Guardar',
            cancel: 'Cancelar',
          },
        },
        mainDrawer: {
          sections: {
            atendimento: 'Atencion',
            gerencia: 'Gerencia',
            campanhas: 'Campanas',
            administracao: 'Administracion',
            sistema: 'Sistema',
          },
          listItems: {
            dashboard: 'Tablero',
            kanban: 'Kanban',
            connections: 'Conexiones',
            groupParticipants: 'Gerenciar Grupos',
            tickets: 'Tickets',
            quickMessages: 'Respuestas Rápidas',
            tasks: 'Tareas',
            contacts: 'Contactos',
            queues: 'Colas y Chatbot',
            tags: 'Etiquetas',
            administration: 'Administración',
            users: 'Usuarios',
            settings: 'Configuraciones',
            helps: 'Ayuda',
            messagesAPI: 'API',
            schedules: 'Agendamientos',
            campaigns: 'Campañas',
            annoucements: 'Anuncios',
            backups: 'Backups',
            chats: 'Chat Interno',
            financeiro: 'Financiero',
            files: 'Lista de archivos',
            prompts: 'Open.Ai',
            queueIntegration: 'Integraciones',
            listagem: 'Listado',
            contactLists: 'Listas de Contactos',
            campaignsConfig: 'Configuraciones',
          },
          appBar: {
            notRegister: 'Sin notificaciones',
            user: {
              profile: 'Perfil',
              logout: 'Salir',
            },
            impersonation: {
              banner: 'Estás accediendo a {{company}} como administrador.',
              back: 'Volver al acceso master',
              enter: 'Acceder como administrador',
            },
          },
        },
        queueIntegration: {
          title: 'Integraciones',
          table: {
            id: 'ID',
            type: 'Tipo',
            name: 'Nombre',
            projectName: 'Nombre del Proyecto',
            language: 'Idioma',
            lastUpdate: 'Última actualización',
            actions: 'Acciones',
          },
          buttons: {
            add: 'Agregar Proyecto',
          },
          searchPlaceholder: 'Buscar...',
          confirmationModal: {
            deleteTitle: 'Eliminar',
            deleteMessage: '¿Estás seguro? ¡Esta acción no se puede deshacer! y se eliminará de las colas y conexiones vinculadas',
          },
          toasts: {
            deleted: '¡Integración eliminada con éxito!',
          },
        },
        files: {
          title: 'Lista de archivos',
          table: {
            name: 'Nombre',
            contacts: 'Contactos',
            actions: 'Acción',
          },
          toasts: {
            deleted: '¡Lista eliminada correctamente!',
            deletedAll: '¡Todas las listas se han eliminado correctamente!',
          },
          buttons: {
            add: 'Agregar',
            deleteAll: 'Eliminar Todos',
          },
          confirmationModal: {
            deleteTitle: 'Eliminar',
            deleteAllTitle: 'Eliminar Todos',
            deleteMessage: '¿Estás seguro de que deseas eliminar esta lista?',
            deleteAllMessage: '¿Estás seguro de que deseas eliminar todas las listas?',
          },
        },
        messagesAPI: {
          title: 'API',
          textMessage: {
            number: 'Número',
            body: 'Mensaje',
            token: 'Token registrado',
          },
          mediaMessage: {
            number: 'Número',
            body: 'Nombre del archivo',
            media: 'Archivo',
            token: 'Token registrado',
          },
        },
        notifications: {
          noTickets: 'No hay notificaciones.',
        },
        quickMessages: {
          title: 'Respuestas Rápidas',
          searchPlaceholder: 'Buscar...',
          noAttachment: 'Sin adjunto',
          confirmationModal: {
            deleteTitle: 'Eliminación',
            deleteMessage: '¡Esta acción es irreversible! ¿Quieres continuar?',
          },
          sendConfirm: {
            title: 'Enviar respuesta rápida',
            message: '¿Está seguro de que desea enviar este mensaje?',
            dontShowAgain: 'No mostrar de nuevo',
            enable: 'Confirmar envío de respuesta rápida',
          },
          buttons: {
            add: 'Agregar',
            attach: 'Adjuntar Archivo',
            cancel: 'Cancelar',
            edit: 'Editar',
          },
          toasts: {
            success: '¡Atajo agregado correctamente!',
            deleted: '¡Atajo eliminado correctamente!',
          },
          dialog: {
            title: 'Mensaje Rápido',
            shortcode: 'Atajo',
            message: 'Respuesta',
            save: 'Guardar',
            cancel: 'Cancelar',
            geral: 'Permitir editar',
            add: 'Agregar',
            edit: 'Editar',
            visao: 'Permitir vista',
            active: 'Activo',
            inactive: 'Inactivo',
            editBeforeSend: 'Editar antes de enviar',
          },
          validation: {
            required: 'Obligatorio',
          },
          table: {
            shortcode: 'Atajo',
            message: 'Mensaje',
            actions: 'Acciones',
            mediaName: 'Nombre del Archivo',
            status: 'Estado',
          },
        },
        messageVariablesPicker: {
          label: 'Variables disponibles',
          vars: {
            contactFirstName: 'Primer Nombre',
            contactName: 'Nombre',
            greeting: 'Saludo',
            protocolNumber: 'Protocolo',
            date: 'Fecha',
            hour: 'Hora',
          },
        },
        contactLists: {
          title: 'Listas de Contactos',
          table: {
            name: 'Nombre',
            contacts: 'Contactos',
            actions: 'Acciones',
          },
          buttons: {
            add: 'Nueva Lista',
          },
          dialog: {
            name: 'Nombre',
            company: 'Empresa',
            okEdit: 'Editar',
            okAdd: 'Agregar',
            add: 'Agregar',
            edit: 'Editar',
            cancel: 'Cancelar',
          },
          confirmationModal: {
            deleteTitle: 'Eliminar',
            deleteMessage: 'Esta acción no se puede deshacer.',
          },
          toasts: {
            deleted: 'Registro eliminado',
          },
        },
        contactListItems: {
          title: 'Contactos',
          searchPlaceholder: 'Búsqueda',
          buttons: {
            add: 'Nuevo',
            lists: 'Listas',
            import: 'Importar',
          },
          dialog: {
            name: 'Nombre',
            number: 'Número',
            whatsapp: 'Whatsapp',
            email: 'Correo electrónico',
            selectContact: 'Seleccionar contacto',
            selectContactPlaceholder: 'Busca un contacto existente',
            noOptions: 'No se encontraron contactos',
            okEdit: 'Editar',
            okAdd: 'Agregar',
            add: 'Agregar',
            edit: 'Editar',
            cancel: 'Cancelar',
          },
          table: {
            name: 'Nombre',
            number: 'Número',
            whatsapp: 'Whatsapp',
            email: 'Correo electrónico',
            actions: 'Acciones',
          },
          confirmationModal: {
            deleteTitle: 'Eliminar',
            deleteMessage: 'Esta acción no se puede deshacer.',
            importMessage: '¿Desea importar los contactos de esta hoja de cálculo?',
            importTitlte: 'Importar',
          },
          toasts: {
            deleted: 'Registro eliminado',
          },
        },
        campaigns: {
          title: 'Campañas',
          searchPlaceholder: 'Búsqueda',
          buttons: {
            add: 'Nueva Campaña',
            contactLists: 'Listas de Contactos',
          },
          table: {
            name: 'Nombre',
            whatsapp: 'Conexión',
            contactList: 'Lista de Contactos',
            status: 'Estado',
            scheduledAt: 'Programada',
            completedAt: 'Completada',
            confirmation: 'Confirmación',
            actions: 'Acciones',
          },
          dialog: {
            new: 'Nueva Campaña',
            update: 'Editar Campaña',
            readonly: 'Solo Lectura',
            form: {
              name: 'Nombre',
              message1: 'Mensaje 1',
              message2: 'Mensaje 2',
              message3: 'Mensaje 3',
              message4: 'Mensaje 4',
              message5: 'Mensaje 5',
              confirmationMessage1: 'Mensaje de Confirmación 1',
              confirmationMessage2: 'Mensaje de Confirmación 2',
              confirmationMessage3: 'Mensaje de Confirmación 3',
              confirmationMessage4: 'Mensaje de Confirmación 4',
              confirmationMessage5: 'Mensaje de Confirmación 5',
              messagePlaceholder: 'Contenido del mensaje',
              whatsapp: 'Conexión',
              status: 'Estado',
              scheduledAt: 'Programada',
              confirmation: 'Confirmación',
              audienceTitle: 'Destinatarios de la campaña',
              audienceDescription: 'Elija una lista existente o use una etiqueta para montar automáticamente el público desde contactos con atenciones etiquetadas.',
              contactList: 'Lista manual de contactos',
              contactListHelper: 'Se usa cuando no hay un público por etiqueta seleccionado.',
              contactListIgnoredHelper: 'Esta lista será ignorada porque el público se montará desde la etiqueta seleccionada.',
              tagList: 'Público por etiqueta',
              tagListHelper: 'Opcional. Al elegir una etiqueta, la campaña usa contactos de atenciones que tienen esa etiqueta.',
              tagListSelectedHelper: 'La campaña creará una lista automática con los contactos encontrados para esta etiqueta.',
              fileList: 'Lista de Archivos',
            },
            buttons: {
              add: 'Agregar',
              edit: 'Actualizar',
              okadd: 'Ok',
              cancel: 'Cancelar',
              restart: 'Reiniciar Campañas',
              close: 'Cerrar',
              attach: 'Adjuntar Archivo',
              report: 'Ver Informe',
            },
          },
          confirmationModal: {
            deleteTitle: 'Eliminar',
            deleteMessage: 'Esta acción no se puede deshacer.',
          },
          toasts: {
            success: 'Operación realizada correctamente',
            cancel: 'Campaña cancelada',
            restart: 'Campañas reiniciadas',
            deleted: 'Registro eliminado',
          },
        },
        announcements: {
          active: 'Activo',
          inactive: 'Inactivo',
          title: 'Informativos',
          searchPlaceholder: 'Búsqueda',
          buttons: {
            add: 'Nuevo Informativo',
            contactLists: 'Listas de Informativos',
          },
          table: {
            priority: 'Prioridad',
            title: 'Título',
            text: 'Texto',
            mediaName: 'Archivo',
            status: 'Estado',
            actions: 'Acciones',
          },
          dialog: {
            edit: 'Editar Informativo',
            add: 'Nuevo Informativo',
            update: 'Editar Informativo',
            readonly: 'Solo Lectura',
            form: {
              priority: 'Prioridad',
              title: 'Título',
              text: 'Texto',
              mediaPath: 'Archivo',
              status: 'Estado',
            },
            buttons: {
              add: 'Agregar',
              edit: 'Actualizar',
              okadd: 'Ok',
              cancel: 'Cancelar',
              close: 'Cerrar',
              attach: 'Adjuntar Archivo',
            },
          },
          confirmationModal: {
            deleteTitle: 'Eliminar',
            deleteMessage: 'Esta acción no se puede deshacer.',
          },
          toasts: {
            success: 'Operación realizada correctamente',
            deleted: 'Registro eliminado',
          },
        },
        campaignsConfig: {
          title: 'Configuraciones de Campañas',
        },
        queues: {
          title: 'Colas y Chatbot',
          table: {
            id: 'ID',
            name: 'Nombre',
            color: 'Color',
            greeting: 'Mensaje de bienvenida',
            actions: 'Acciones',
            orderQueue: 'Orden de la cola (bot)',
          },
          buttons: {
            add: 'Agregar cola',
            flow: 'Ver flujo del bot',
            test: 'Probar flujo del bot',
          },
          confirmationModal: {
            deleteTitle: 'Eliminar',
            deleteMessage: '¿Estás seguro? ¡Esta acción no se puede deshacer! Los tickets de esta cola seguirán existiendo pero ya no tendrán ninguna cola asignada.',
          },
          flow: {
            title: 'Flujo del Bot',
            autoArrange: 'Organizar flujo',
            exportImage: 'Generar imagen',
          },
          test: {
            title: 'Prueba del flujo del bot',
            placeholder: 'Escribe un mensaje',
            send: 'Enviar',
            close: 'Cerrar',
          },
        },
        queueSelect: {
          inputLabel: 'Colas',
          moveQueue: 'Mover a cola',
          timeToMove: 'Tiempo para mover',
          timeToClose: 'Tiempo para inactividad',
        },
        users: {
          title: 'Usuarios',
          table: {
            id: 'ID',
            name: 'Nombre',
            email: 'Email',
            profile: 'Perfil',
            actions: 'Acciones',
          },
          buttons: {
            add: 'Agregar usuario',
          },
          toasts: {
            deleted: 'Usuario eliminado correctamente.',
          },
          confirmationModal: {
            deleteTitle: 'Eliminar',
            deleteMessage: 'Todos los datos del usuario se perderán. Los tickets abiertos de este usuario se moverán a la cola.',
          },
        },
        helps: {
          title: 'Centro de Ayuda',
          searchPlaceholder: 'Buscar por título o descripción',
          all: 'Todos',
        },
        schedules: {
          title: 'Agendamientos',
          confirmationModal: {
            deleteTitle: '¿Estás seguro que quieres eliminar este Agendamiento?',
            deleteMessage: 'Esta acción no se puede deshacer.',
            deleteRecurringMessage: 'Al eliminar, se eliminarán todos los agendamientos vinculados a este.',
          },
          table: {
            contact: 'Contacto',
            body: 'Mensaje',
            sendAt: 'Fecha de Agendamiento',
            sentAt: 'Fecha de Envío',
            status: 'Estado',
            actions: 'Acciones',
          },
          buttons: {
            add: 'Nuevo Agendamiento',
          },
          viewModal: {
            title: 'Detalles del Agendamiento',
            attachment: 'Adjunto',
            buttons: {
              edit: 'Editar',
              close: 'Cerrar',
            },
            media: {
              view: 'Ver',
              download: 'Descargar',
            },
          },
          toasts: {
            deleted: 'Agendamiento eliminado correctamente.',
            cannotEditPast: 'No es posible editar agendamientos pasados.',
            editRecurringInfo: 'Este agendamiento es recurrente. Los cambios solo afectarán a los próximos envíos.',
            editRecurringSingleInfo: 'Los cambios se aplicarán solo a este agendamiento. Para alterar todos, edite el agendamiento principal.',
          },
        },
        tags: {
          title: 'Etiquetas',
          confirmationModal: {
            deleteTitle: '¿Estás seguro que quieres eliminar esta Etiqueta?',
            deleteMessage: 'Esta acción no se puede deshacer.',
            deleteAllMessage: '¿Estás seguro que quieres eliminar todas las Etiquetas?',
            deleteAllTitle: 'Eliminar Todas',
          },
          table: {
            name: 'Nombre',
            color: 'Color',
            tickets: 'Tickets Etiquetados',
            kanban: 'Kanban',
            yes: 'Sí',
            no: 'No',
            actions: 'Acciones',
          },
          buttons: {
            add: 'Nueva Etiqueta',
            deleteAll: 'Eliminar Todas',
          },
          toasts: {
            deletedAll: '¡Todas las Etiquetas se han eliminado correctamente!',
            deleted: 'Etiqueta eliminada correctamente.',
          },
        },
        customKanban: {
          title: 'Kanban Personalizado',
          subtitle: 'Crea tableros personalizados para organizar tus procesos.',
          menuLabel: 'Kanban Personalizado',
          sections: {
            boards: 'Tableros',
            items: 'Elementos del tablero',
            boardView: 'Tablero',
          },
          actions: {
            addBoard: 'Agregar',
            createBoard: 'Crear tablero',
            addColumn: 'Agregar columna',
            addItem: 'Agregar elemento',
            addContact: 'Agregar contacto',
            removeItem: 'Quitar del kanban',
            goToConversation: 'Ir a la conversación',
            editBoard: 'Editar tablero',
            editColumn: 'Editar columna',
            deleteBoard: 'Eliminar tablero',
            deleteColumn: 'Eliminar columna',
            edit: 'Editar',
            delete: 'Eliminar',
            shareBoard: 'Compartir',
            moreOptions: 'Más opciones',
            saveChanges: 'Guardar cambios',
            close: 'Cerrar',
          },
          form: {
            boardName: 'Nombre del tablero',
            columnName: 'Nombre de la columna',
            columnColor: 'Color de la columna',
            columnSelect: 'Seleccione una columna',
            targetType: 'Tipo de elemento',
            contactOption: 'Contacto',
            ticketOption: 'Ticket',
            contactId: 'ID del contacto',
            ticketId: 'ID del ticket',
            searchPlaceholder: 'Buscar por nombre o número del contacto',
            sharedUsers: 'Compartir con',
            sharedUsersPlaceholder: 'Seleccione usuarios para compartir el tablero',
            sharedUsersLoading: 'Cargando usuarios...',
            sharedUsersNoOptions: 'No se encontraron usuarios',
          },
          labels: {
            columnsCount: 'Columnas: {{count}}',
            itemsCount: 'Elementos: {{count}}',
            totalItems: 'Total de elementos: {{count}}',
            contactInfo: 'Contacto #{{id}}',
            ticketInfo: 'Ticket #{{id}}',
            contactWithoutName: 'Contacto sin nombre',
            ticketWithoutSubject: 'Ticket sin asunto',
            contactNumber: 'Número: {{number}}',
            contactWithoutNumber: 'Contacto sin número',
            sharedWith: 'Compartido con',
            sharedWithCount: 'Compartido con {{count}} usuario(s)',
            you: 'Tú',
          },
          emptyStates: {
            noBoards: 'Aún no hay tableros creados.',
            selectBoard: 'Seleccione o cree un tablero para comenzar.',
            noColumns: 'Todavía no hay columnas en este tablero.',
            noItems: 'Todavía no hay elementos en esta columna.',
            noContacts: 'No se encontraron contactos con esos filtros.',
            noSharedUsers: 'Solo tú puedes ver este tablero por ahora.',
          },
          toasts: {
            loadError: 'No fue posible cargar los tableros de kanban.',
            boardCreated: 'Tablero creado con éxito.',
            boardUpdated: 'Tablero actualizado con éxito.',
            boardDeleted: 'Tablero eliminado con éxito.',
            boardError: 'No fue posible crear el tablero.',
            boardUpdateError: 'No fue posible actualizar el tablero.',
            boardDeleteError: 'No fue posible eliminar el tablero.',
            columnCreated: 'Columna agregada con éxito.',
            columnUpdated: 'Columna actualizada con éxito.',
            columnDeleted: 'Columna eliminada con éxito.',
            columnMoved: 'Columna movida con éxito.',
            columnError: 'No fue posible agregar la columna.',
            columnUpdateError: 'No fue posible actualizar la columna.',
            columnDeleteError: 'No fue posible eliminar la columna.',
            columnMoveError: 'No fue posible mover la columna.',
            itemCreated: 'Elemento agregado con éxito.',
            itemError: 'No fue posible agregar el elemento.',
            itemMoved: 'Elemento movido con éxito.',
            itemMoveError: 'No fue posible mover el elemento.',
            itemDeleted: 'Elemento eliminado con éxito.',
            itemDeleteError: 'No fue posible eliminar el elemento.',
            contactLoadError: 'No fue posible cargar los contactos.',
            sharedUsersLoadError: 'No fue posible cargar los usuarios para compartir el tablero.',
            boardPermissionError: 'Solo el propietario del tablero puede realizar esta acción.',
            ticketNavigationError: 'No fue posible encontrar el ticket para este elemento.',
          },
          validations: {
            boardName: 'Informe un nombre para el tablero.',
            columnName: 'Informe un nombre para la columna.',
            selectBoard: 'Seleccione un tablero antes de continuar.',
            selectColumn: 'Seleccione una columna.',
            targetId: 'Informe el identificador del contacto o ticket.',
            targetNumber: 'Informe un identificador numérico válido.',
          },
          dialogs: {
            addBoardTitle: 'Crear nuevo tablero',
            editBoardTitle: 'Editar tablero',
            addContactTitle: 'Agregar contacto a la columna',
            addColumnTitle: 'Agregar nueva columna',
            editColumnTitle: 'Editar columna',
            deleteBoardTitle: 'Eliminar tablero',
            deleteColumnTitle: 'Eliminar columna',
          },
          confirmations: {
            deleteBoard: '¿Eliminar el tablero "{{name}}"? Esta acción no se puede deshacer.',
            deleteColumn: '¿Eliminar la columna "{{name}}" y todos sus elementos?',
          },
        },
        settings: {
          success: 'Configuraciones guardadas correctamente.',
          title: 'Configuraciones',
          settings: {
            userCreation: {
              name: 'Creación de usuario',
              options: {
                enabled: 'Habilitado',
                disabled: 'Deshabilitado',
              },
            },
            timezone: {
              name: 'Zona horaria',
            },
          },
        },
        messagesList: {
          header: {
            assignedTo: 'Asignado a:',
            notMessage: 'No hay mensajes en este ticket.',
            buttons: {
              return: 'Volver',
              resolve: 'Resolver',
              reopen: 'Reabrir',
              accept: 'Aceptar',
              closeWithoutBot: 'Finalizar sin notificación',
            },
          },
          privateMessage: {
            label: 'Nota privada · {{name}}',
            unknownAuthor: 'Agente',
            deleted: 'Esta nota fue eliminada.',
            options: 'Opciones de la nota',
          },
        },
        showTicketLogModal: {
          title: {
            header: 'Historial del Ticket',
          },
          options: {
            create: 'Creado',
            chatBot: 'Bot',
            queue: 'Cola',
            open: 'Abierto',
            access: 'Acceso',
            transfered: 'Transferido',
            receivedTransfer: 'Recibió transferencia',
            pending: 'Pendiente',
            closed: 'Cerrado',
            reopen: 'Reabierto',
            redirect: 'Redirigido',
          },
        },
        frontEndErrors: {
          getUsers: 'Error al cargar usuarios.',
        },
        allTicket: {
          form: {
            viewTags: 'Ver etiquetas',
          },
        },
        messagesInput: {
          placeholderOpen: 'Escribe un mensaje',
          placeholderClosed: 'Reabra o acepte este ticket para enviar un mensaje.',
          signMessage: 'Firmar',
          pendingTicketInfo: 'Este ticket está en espera. Acéptalo antes de responder los mensajes.',
          privateMode: {
            label: 'Tipo de envío',
            message: 'Mensaje',
            note: 'Nota privada',
            placeholder: 'Escribe una nota para el equipo…',
            save: 'Guardar nota',
            hint: 'Solo el equipo ve esta nota. El cliente no recibe nada en WhatsApp.',
          },
        },
        contactDrawer: {
          header: 'Datos del contacto',
          buttons: {
            edit: 'Editar contacto',
          },
          block: {
            title: 'Bloqueo',
            blockedLabel: 'Este contacto está bloqueado en WhatsApp y no puede enviar mensajes a la conexión.',
            block: 'Bloquear contacto',
            unblock: 'Desbloquear contacto',
            confirmBlockTitle: '¿Bloquear este contacto?',
            confirmBlockMessage: 'El número será bloqueado en el WhatsApp de la conexión de este ticket y dejará de enviarle mensajes. Puede desbloquearlo después desde este panel.',
            confirmUnblockTitle: '¿Desbloquear este contacto?',
            confirmUnblockMessage: 'El número podrá volver a enviar mensajes a la conexión de este ticket.',
            blocked: 'Contacto bloqueado.',
            unblocked: 'Contacto desbloqueado.',
          },
          crm: {
            title: 'CRM',
            inCrm: 'Este contacto ya tiene una oportunidad abierta en el CRM.',
            notInCrm: 'Este contacto todavía no tiene una oportunidad abierta en el CRM.',
            moveAction: 'Mover en CRM',
            addAction: 'Agregar al CRM',
            transferAction: 'Copiar / mover',
            openCount: '{{count}} oportunidades abiertas en el CRM',
          },
          extraInfo: 'Información adicional',
          group: {
            title: 'Integrantes del grupo',
            refresh: 'Actualizar',
            add: 'Agregar miembros',
            remove: 'Eliminar',
            empty: 'No se encontraron integrantes para este grupo.',
            missingIdentifiers: 'No fue posible administrar los participantes de este contacto.',
            count: 'Integrantes: {{count}}',
            unknown: 'Desconocido',
            roles: {
              admin: 'Admin',
              superAdmin: 'Super admin',
            },
            modal: {
              title: 'Agregar integrantes al grupo',
              description: 'Busca y selecciona contactos existentes para agregarlos a este grupo.',
              searchLabel: 'Contactos',
              searchPlaceholder: 'Escribe para buscar contactos',
              loading: 'Cargando contactos...',
              noOptions: 'No se encontraron contactos',
              cancel: 'Cancelar',
              confirm: 'Agregar miembros',
            },
            toasts: {
              missingInformation: 'Información insuficiente para administrar este grupo.',
              noContacts: 'Selecciona al menos un contacto para continuar.',
              addSuccess: '¡Participantes agregados con éxito!',
              removeSuccess: '¡Participante eliminado con éxito!',
            },
            confirmation: {
              title: 'Eliminar participante',
              message: '¿Deseas realmente eliminar a {{name}} de este grupo?',
            },
          },
        },
        fileModal: {
          title: {
            add: 'Agregar lista de archivos',
            edit: 'Editar lista de archivos',
          },
          buttons: {
            okAdd: 'Guardar',
            okEdit: 'Editar',
            cancel: 'Cancelar',
            fileOptions: 'Agregar archivo',
          },
          form: {
            name: 'Nombre de la lista de archivos',
            message: 'Detalles de la lista',
            fileOptions: 'Lista de archivos',
            extraName: 'Mensaje para enviar con archivo',
            extraValue: 'Valor de la opción',
          },
          success: 'Lista de archivos guardada correctamente!',
        },
        ticketOptionsMenu: {
          addToCrm: 'Agregar al CRM',
          schedule: 'Programación',
          delete: 'Eliminar',
          transfer: 'Transferir',
          closeWithoutBot: 'Finalizar sin mensaje del bot',
          closeWithoutBotModal: {
            title: 'Finalizar sin mensaje del bot',
            message: 'El ticket se cerrará sin enviar el mensaje de cierre al cliente.',
          },
          registerAppointment: 'Observaciones del Contacto',
          appointmentsModal: {
            title: 'Observaciones del Contacto',
            textarea: 'Observación',
            placeholder: 'Inserta aquí la información que deseas registrar',
          },
          confirmationModal: {
            title: 'Eliminar el ticket',
            titleFrom: 'del contacto ',
            message: '¡Atención! Todos los mensajes relacionados con el ticket se perderán.',
          },
          buttons: {
            delete: 'Eliminar',
            cancel: 'Cancelar',
          },
        },
        crm: {
          title: 'CRM Comercial',
          subtitle: 'Sigue las oportunidades por contacto y mueve cada negocio por el embudo.',
          menuLabel: 'CRM Comercial',
          conversionsMenuLabel: 'Conversiones CRM',
          reportsMenuLabel: 'Informes CRM',
          menu: {
            board: 'Embudo de ventas',
            conversions: 'Conversiones',
            reports: 'Informes',
            settings: 'Configuración',
          },
          products: {
            manage: 'Productos/servicios',
            managerTitle: 'Productos y servicios',
            managerDescription: 'Registra lo que vendes para vincularlo a las oportunidades del CRM.',
            add: 'Nuevo producto/servicio',
            addTitle: 'Registrar producto/servicio',
            editTitle: 'Editar producto/servicio',
            edit: 'Editar',
            delete: 'Eliminar',
            name: 'Nombre',
            type: 'Tipo',
            typeProduct: 'Producto',
            typeService: 'Servicio',
            price: 'Precio',
            description: 'Descripción',
            active: 'Activo',
            inactive: 'Inactivo',
            search: 'Buscar producto/servicio',
            noResults: 'No se encontraron productos/servicios.',
            createFromSearch: 'Registrar "{{name}}"',
            create: 'Registrar producto/servicio',
            assign: 'Asignar producto/servicio',
            remove: 'Quitar producto/servicio',
            noPrice: 'Sin precio',
            label: 'Producto/servicio',
            deleteConfirmation: '¿Eliminar "{{name}}"? Solo se pueden eliminar ítems sin oportunidades vinculadas; en caso contrario, desactívalo.',
            toasts: {
              nameRequired: 'Informa el nombre del producto/servicio.',
              invalidPrice: 'Informa un precio válido.',
              created: '¡Producto/servicio registrado con éxito!',
              updated: '¡Producto/servicio actualizado con éxito!',
              deleted: '¡Producto/servicio eliminado con éxito!',
              assigned: '¡Producto/servicio asignado a la oportunidad!',
              removed: '¡Producto/servicio quitado de la oportunidad!',
            },
          },
          transfer: {
            menuItem: 'Copiar o mover a otro pipeline',
            title: 'Copiar o mover oportunidad',
            description: 'Elige a dónde debe ir "{{name}}".',
            copy: 'Copiar',
            move: 'Mover',
            copyHelper: 'Crea una nueva oportunidad en el destino y mantiene la original donde está (se copian tags y producto).',
            moveHelper: 'Lleva la oportunidad al destino, manteniendo historial, tags, producto y follow up.',
            targetPipeline: 'Pipeline de destino',
            targetStage: 'Stage de destino',
            currentPipeline: '(actual)',
            targetRequired: 'Selecciona el pipeline y el stage de destino.',
            copied: '¡Oportunidad copiada con éxito!',
            moved: '¡Oportunidad movida con éxito!',
          },
          reports: {
            title: 'Informes del CRM',
            subtitle: 'Genera listados y análisis de las oportunidades y expórtalos a Excel o CSV.',
            periodHint: 'Considera las oportunidades creadas en el período seleccionado.',
            types: {
              opportunities: {
                title: 'Listado de oportunidades',
                description: 'Todas las oportunidades con contacto, pipeline, stage, producto, valor y estado.',
              },
              products: {
                title: 'Ventas por producto/servicio',
                description: 'Cantidad, valores ganados, perdidos y conversión de cada producto/servicio.',
              },
              owners: {
                title: 'Desempeño por responsable',
                description: 'Resultados de cada responsable: oportunidades, ganadas, perdidas y ticket medio.',
              },
            },
            filters: {
              startDate: 'Fecha inicial',
              endDate: 'Fecha final',
              pipeline: 'Pipeline',
              allPipelines: 'Todos los pipelines',
              stage: 'Stage',
              allStages: 'Todos los stages',
              status: 'Estado',
              allStatuses: 'Todos los estados',
              product: 'Producto/servicio',
              allProducts: 'Todos los productos/servicios',
              noProduct: 'Sin producto/servicio',
              owner: 'Responsable',
              allOwners: 'Todos los responsables',
              noOwner: 'Sin responsable',
              apply: 'Generar informe',
            },
            exportXlsx: 'Exportar Excel',
            exportCsv: 'Exportar CSV',
            empty: 'No hay resultados para los filtros seleccionados.',
            rowsCount: '{{count}} registro(s)',
            total: 'Total',
            status: {
              open: 'Abierta',
              won: 'Ganada',
              lost: 'Perdida',
            },
            columns: {
              id: 'ID',
              title: 'Oportunidad',
              status: 'Estado',
              contact: 'Contacto',
              number: 'Teléfono',
              email: 'Correo',
              pipeline: 'Pipeline',
              stage: 'Stage',
              product: 'Producto/servicio',
              productType: 'Tipo',
              owner: 'Responsable',
              amount: 'Valor',
              source: 'Origen',
              lossCategory: 'Categoría de pérdida',
              lostReason: 'Motivo de pérdida',
              tags: 'Tags',
              expectedCloseDate: 'Previsión de cierre',
              createdAt: 'Creada el',
              updatedAt: 'Actualizada el',
              totalCount: 'Oportunidades',
              totalAmount: 'Valor total',
              openCount: 'Abiertas',
              openAmount: 'Valor abierto',
              wonCount: 'Ganadas',
              wonAmount: 'Valor ganado',
              lostCount: 'Perdidas',
              lostAmount: 'Valor perdido',
              conversionRate: 'Conversión',
              averageWonTicket: 'Ticket medio',
            },
            summary: {
              count: 'Oportunidades',
              totalAmount: 'Valor total',
              wonAmount: 'Valor ganado',
              conversionRate: 'Tasa de conversión',
            },
          },
          actions: {
            pipelineOptions: 'Opciones del pipeline',
            moreOptions: 'Más opciones',
            clearSearch: 'Limpiar búsqueda',
            managePipeline: 'Gestionar pipeline',
            manageStages: 'Gestionar stages',
            searchOpportunities: 'Buscar por nombre, título o teléfono',
            addPipeline: 'Crear pipeline',
            editPipeline: 'Editar pipeline',
            duplicatePipeline: 'Duplicar pipeline',
            deletePipeline: 'Eliminar pipeline',
            deleteStage: 'Eliminar stage',
            selectPipeline: 'Seleccionar',
            addStage: 'Nuevo',
            editStage: 'Editar stage',
            moveStageUp: 'Mover stage hacia arriba',
            moveStageDown: 'Mover stage hacia abajo',
            addOpportunity: 'Nueva oportunidad',
            addOpportunityToStage: 'Nueva oportunidad en este stage',
            openConversation: 'Ir a la conversación',
            previewConversation: 'Espiar conversación',
            deleteOpportunity: 'Eliminar oportunidad',
            moveOpportunity: 'Mover oportunidad',
            moveToStage: 'Mover a {{name}}',
            markWon: 'Marcar como ganada',
            markLost: 'Marcar como perdida',
            showLostStage: 'Ver perdidas',
            hideLostStage: 'Ocultar perdidas',
            manageLossCategories: 'Gestionar motivos de pérdida',
            addLossCategory: 'Nuevo',
            editLossCategory: 'Editar motivo de pérdida',
            deleteLossCategory: 'Eliminar motivo de pérdida',
            activateLossCategory: 'Activar',
            deactivateLossCategory: 'Desactivar',
            cancel: 'Cancelar',
            confirm: 'Confirmar',
            create: 'Crear',
            complete: 'Completar',
            close: 'Cerrar',
            delete: 'Eliminar',
            save: 'Guardar',
            viewConversions: 'Ver conversiones',
            openSettings: 'Configuración del CRM',
            backToCrm: 'Volver al CRM',
            refreshConversions: 'Actualizar reporte',
            completeFollowUp: 'Completar follow up',
            manageTags: 'Gestionar tags',
            addTag: 'Agregar tag',
            createTag: 'Crear nueva',
            editTag: 'Editar tag',
            deleteTag: 'Eliminar tag',
            edit: 'Editar',
          },
          form: {
            pipeline: 'Pipeline',
            pipelineName: 'Nombre del pipeline',
            stage: 'Stage',
            stageName: 'Nombre del stage',
            stageColor: 'Color del stage',
            autoMarkAsWon: 'Marcar como ganada automáticamente al mover a este stage',
            title: 'Título de la oportunidad',
            contact: 'Contacto',
            opportunity: 'Oportunidad existente',
            amount: 'Valor estimado',
            expectedCloseDate: 'Previsión de cierre',
            notes: 'Notas',
            followUpFilter: 'Filtro de follow up',
            tagFilter: 'Filtrar por tags',
            tagFilterEmpty: 'No se encontraron tags',
            followUpResponsible: 'Responsable del follow up',
            followUpDueAt: 'Próximo follow up',
            followUpNote: 'Nota del follow up',
            lostReason: 'Motivo de la pérdida',
            lossCategory: 'Categoría de la pérdida',
            lossCategoryName: 'Nombre de la categoría',
            lossCategoryActive: 'Categoría activa',
            tagName: 'Texto de la tag',
            tagColor: 'Color de la tag',
            searchTag: 'Buscar o crear tag',
          },
          labels: {
            opportunityCount: '{{count}} oportunidad(es)',
            stageCount: '{{count}} stage(s)',
            pipelineCopyName: 'Copia de {{name}}',
            duplicatePipelineHelper: 'Solo se copiarán los lanes y sus configuraciones, sin leads ni historial.',
            noContact: 'Contacto no identificado',
            noNumber: 'Sin número',
            unassigned: 'Sin responsable',
            source: 'Origen',
            sourceTicket: 'Ticket manual',
            sourceTicketAuto: 'Ticket automático',
            sourceManual: 'Manual',
            noAmount: 'Sin valor',
            stageTime: 'En esta etapa desde {{date}}',
            stageTimeNow: 'ahora',
            expectedCloseDate: 'Cierre',
            followUp: 'Follow up',
            followUpResponsible: 'Responsable del follow up',
            followUpDueAt: 'Próximo follow up',
            followUpHistory: 'Historial de follow up',
            followUpOutcomeAt: 'Cerrado en',
            conversationActions: 'Conversación',
            timeline: 'Timeline de la negociación',
            actor: 'Responsable',
            system: 'Sistema',
            ticketReference: 'Ticket #{{id}}',
            autoWonStage: 'Stage final',
            wonStatus: 'Ganada',
            lostStatus: 'Perdida',
            lostStage: 'Perdidas',
            lostReason: 'Motivo de la pérdida',
            lossCategory: 'Categoría de la pérdida',
            lossCategoryActive: 'Activa',
            lossCategoryInactive: 'Inactiva',
            sortStageTimeLongestFirst: 'Ordenar por tiempo en la etapa: mayor tiempo primero',
            sortStageTimeShortestFirst: 'Ordenar por tiempo en la etapa: menor tiempo primero',
            crmTags: 'Tags comerciales',
          },
          emptyStates: {
            noPipelines: 'Crea un pipeline para empezar el CRM.',
            noOpportunities: 'No hay oportunidades en este stage.',
            noStages: 'No hay stages creados en este pipeline.',
            noTimeline: 'No hay eventos registrados para esta oportunidad.',
            noFollowUp: 'No hay follow up agendado.',
            noFollowUpHistory: 'No hay follow ups anteriores registrados.',
            noFollowUpNote: 'Sin nota de follow up.',
            noLossCategories: 'No hay categorías de pérdida creadas.',
            noTags: 'No se encontraron tags.',
          },
          dialogs: {
            addPipeline: 'Crear pipeline',
            editPipeline: 'Editar pipeline',
            duplicatePipeline: 'Duplicar pipeline',
            managePipeline: 'Gestionar pipelines',
            deletePipeline: 'Eliminar pipeline',
            manageStages: 'Gestionar stages',
            addStage: 'Crear stage',
            editStage: 'Editar stage',
            deleteStage: 'Eliminar stage',
            addOpportunity: 'Crear oportunidad',
            opportunityDetails: 'Detalles de la oportunidad',
            deleteOpportunity: 'Eliminar oportunidad',
            deleteOpportunityConfirmation: '¿Deseas eliminar esta oportunidad? Esta acción no se puede deshacer.',
            markWon: 'Marcar oportunidad como ganada',
            markLost: 'Marcar oportunidad como perdida',
            manageLossCategories: 'Gestionar motivos de pérdida',
            addLossCategory: 'Crear motivo de pérdida',
            editLossCategory: 'Editar motivo de pérdida',
            manageTags: 'Gestionar tags',
            addTag: 'Crear tag',
            editTag: 'Editar tag',
          },
          ticketDialog: {
            title: 'Agregar contacto al CRM',
            description: 'Define dónde debe entrar {{name}} en el embudo comercial.',
            createMode: 'Crear una nueva oportunidad',
            reuseMode: 'Usar una oportunidad existente',
            alreadyInCrmTitle: 'El contacto ya está en el CRM',
            alreadyInCrmDescription: 'Este contacto ya tiene {{count}} oportunidad(es) abierta(s). Posición actual: {{pipeline}} > {{stage}}.',
            notInCrmTitle: 'El contacto aún no está en el CRM',
            notInCrmDescription: 'Puedes crear una nueva oportunidad para empezar el seguimiento comercial.',
            currentPipeline: 'Pipeline actual',
            destinationStage: 'Mover a la etapa',
            reuseHelper: 'Selecciona la oportunidad existente y elige solo la nueva etapa dentro del pipeline actual.',
          },
          confirmations: {
            winOpportunity: '¿Deseas marcar "{{name}}" como oportunidad ganada?',
            deletePipeline: '¿Deseas eliminar el pipeline "{{name}}"? Esta acción elimina los stages y oportunidades vinculados.',
            deleteStage: '¿Deseas eliminar el stage "{{name}}"? Esta acción solo está permitida cuando no tiene oportunidades vinculadas.',
            deleteOpportunity: '¿Deseas eliminar la oportunidad "{{name}}"?',
          },
          toasts: {
            pipelineRequired: 'Selecciona un pipeline antes de continuar.',
            pipelineNameRequired: 'Ingresa el nombre del pipeline.',
            stageNameRequired: 'Ingresa el nombre del stage.',
            opportunityFormRequired: 'Selecciona el contacto y el stage de la oportunidad.',
            pipelineStageRequired: 'Selecciona el pipeline y el stage.',
            opportunityRequired: 'Selecciona la oportunidad que se reutilizará.',
            pipelineCreated: '¡Pipeline creado con éxito!',
            pipelineDuplicated: '¡Pipeline duplicado con éxito!',
            pipelineUpdated: '¡Pipeline actualizado con éxito!',
            pipelineDeleted: '¡Pipeline eliminado con éxito!',
            stageCreated: '¡Stage creado con éxito!',
            stageUpdated: '¡Stage actualizado con éxito!',
            stageDeleted: '¡Stage eliminado con éxito!',
            stageOrderUpdated: '¡Orden de stages actualizada con éxito!',
            lossCategoryRequired: 'Selecciona una categoría de pérdida.',
            lossCategoryNameRequired: 'Ingresa el nombre de la categoría de pérdida.',
            lossCategoryCreated: '¡Categoría de pérdida creada con éxito!',
            lossCategoryUpdated: '¡Categoría de pérdida actualizada con éxito!',
            lossCategoryDeleted: '¡Categoría de pérdida eliminada con éxito!',
            automationSettingsSaved: '¡Configuración de automatización guardada con éxito!',
            opportunityCreated: '¡Oportunidad creada con éxito!',
            opportunityUpdated: '¡Oportunidad actualizada con éxito!',
            opportunityMoved: '¡Oportunidad movida con éxito!',
            opportunityWon: '¡Oportunidad marcada como ganada!',
            opportunityLost: '¡Oportunidad marcada como perdida!',
            opportunityDeleted: '¡Oportunidad eliminada con éxito!',
            ticketAdded: '¡Contacto enviado al CRM con éxito!',
            ticketConversationNotFound: 'No fue posible localizar la conversación de este ticket desde el CRM.',
            automationTriggerRequired: 'Informe al menos una cola o palabra clave para activar la automatización.',
            automationDaysInvalid: 'Informa un número de días entre 1 y 365.',
            automationLossCategoryRequired: 'Selecciona el motivo de pérdida por inactividad.',
            followUpRequired: 'Informa responsable y fecha/hora para guardar el follow up.',
            followUpRequiredFields: 'Informa responsable y fecha/hora para guardar el follow up.',
            followUpSaved: '¡Follow up guardado con éxito!',
            followUpCompleted: '¡Follow up completado con éxito!',
            tagNameRequired: 'Ingresa el texto de la tag.',
            tagCreated: '¡Tag creada con éxito!',
            tagUpdated: '¡Tag actualizada con éxito!',
            tagDeleted: '¡Tag eliminada con éxito!',
          },
          followUp: {
            filters: {
              all: 'Todos',
              pending: 'Pendientes',
              today: 'Hoy',
              overdue: 'Atrasados',
              assigned_to_me: 'Asignados a mí',
            },
            status: {
              pending: 'Pendiente',
              today: 'Hoy',
              overdue: 'Atrasado',
            },
          },
          settings: {
            title: 'Configuración del CRM',
            subtitle: 'Centraliza los motivos de pérdida y configura la entrada automática de leads por pipeline.',
            automationTitle: 'Automatización por pipeline',
            automationDescription: 'Crea automáticamente un nuevo lead cuando el ticket coincida con las palabras clave configuradas o entre en una de las colas seleccionadas.',
            automationEnabled: 'Automático',
            triggerLabel: 'Disparador',
            triggers: {
              accept_ticket: 'Al aceptar ticket',
              message_received: 'Al recibir mensaje o entrar en la cola',
            },
            triggerHelpers: {
              accept_ticket: 'El lead se crea cuando un agente acepta el ticket.',
              message_received: 'El lead se crea en cuanto el cliente envía una palabra clave o el ticket entra en una de las colas, antes de que alguien lo acepte.',
            },
            firstContactRuleLabel: 'Regla de contacto',
            firstContactOnly: 'Solo en el primer ticket del contacto',
            allTickets: 'Todos los tickets',
            contactRuleHelper: 'En todos los casos, no se crea un nuevo lead si el contacto ya tiene una oportunidad abierta en este pipeline.',
            targetStage: 'Stage de entrada',
            defaultProduct: 'Producto/servicio predeterminado',
            defaultProductHelper: 'Se vincula al lead creado automáticamente. El precio del producto se convierte en el valor de la oportunidad.',
            noDefaultProduct: 'Ninguno',
            funnelAutomationsTitle: 'Automatizaciones del embudo',
            funnelAutomationsDescription: 'Acciones automáticas sobre las oportunidades de este pipeline. Funcionan incluso con la creación automática desactivada.',
            acceptTicketStageId: 'Al aceptar ticket, mover a',
            closeTicketStageId: 'Al finalizar ticket, mover a',
            moveStageHelper: 'Mueve la oportunidad abierta del contacto solo hacia adelante en el embudo.',
            doNotMove: 'No mover',
            staleFollowUpDays: 'Crear follow-up tras días detenida en el stage',
            staleFollowUpDaysHelper: 'Crea un follow-up para el responsable cuando la oportunidad pasa esa cantidad de días en el mismo stage. Déjalo vacío para desactivar.',
            inactivityLossDays: 'Marcar como perdida tras días sin respuesta',
            inactivityLossDaysHelper: 'Marca como perdida la oportunidad en la que el cliente no envía mensajes en ese período. Déjalo vacío para desactivar.',
            inactivityLossCategory: 'Motivo de pérdida por inactividad',
            logCustomerMessages: 'Registrar mensajes del cliente en la línea de tiempo',
            logCustomerMessagesHelper: 'Cuando el cliente envía un mensaje, lo registra en la línea de tiempo de la oportunidad abierta (como máximo una vez al día) y deja de contar como detenida.',
            keywords: 'Palabras clave',
            keywordsHelper: 'Escribe una palabra clave y presiona Enter para crear un chip. Haz clic en la x del chip para eliminarlo.',
            keywordsPlaceholder: 'Escribe y presiona Enter',
            queues: 'Colas',
            queuesHelper: 'Seleccione una o más colas. Si el ticket está en cualquiera de ellas, el lead se creará automáticamente.',
            queuesPlaceholder: 'Seleccione las colas',
            saveAutomation: 'Guardar automatización',
            lossCategoryDescription: 'Organiza los motivos usados cuando una oportunidad se marca como perdida.',
          },
          conversions: {
            title: 'Dashboard de flujo comercial CRM',
            subtitle: 'Sigue cuántas oportunidades fueron creadas, ganadas y perdidas para identificar fugas y oportunidades en el embudo.',
            alertsTitle: 'Alertas rapidas',
            alertsSubtitle: 'Prioridades para actuar apenas cargue el dashboard.',
            allPipelines: 'Todos los pipelines',
            startDate: 'Fecha inicial',
            endDate: 'Fecha final',
            granularity: 'Granularidad',
            daily: 'Diario',
            weekly: 'Semanal',
            monthly: 'Mensual',
            day: 'día',
            days: 'días',
            hoursShort: 'h',
            minutesShort: 'min',
            chartTitle: 'Evolución del volumen de ganancias y pérdidas',
            pipelineBreakdown: 'Desempeño por pipeline',
            previousPeriodComparison: 'Comparativo con el período anterior',
            pipelineByValue: 'Pipeline por valor',
            pipelineOpenTotal: '{{count}} oportunidad(es) abierta(s)',
            downloadCsv: 'Descargar CSV',
            downloadImage: 'Descargar imagen',
            pipelineHealth: 'Salud del pipeline',
            averageTimeByStage: 'Tiempo promedio por stage',
            averageTimeByStageDescription: 'Cuánto tiempo tardaron las oportunidades en salir de cada stage (avanzar, ganar o perder), considerando las salidas en el período.',
            stayCount: '{{count}} paso(s)',
            averageStageDays: 'Tiempo promedio',
            openAging: 'Oportunidades detenidas',
            staleOver7: 'Detenidas +7 dias',
            status: 'Estado',
            lossCategoryBreakdown: 'Motivos de pérdida',
            mainLossReason: 'Motivo principal de pérdida',
            averageLostTicket: 'Ticket promedio perdido',
            stageFunnel: 'Embudo por stage',
            share: 'Participación',
            metric: 'Métrica',
            currentPeriod: 'Período actual',
            previousPeriod: 'Período anterior',
            variation: 'Variación',
            emptyChart: 'No se encontraron datos para el período seleccionado.',
            emptyBreakdown: 'No se encontraron resultados para los filtros actuales.',
            emptyLosses: 'No se encontraron pérdidas para el período seleccionado.',
            statusOptions: {
              healthy: 'Saludable',
              attention: 'Atención',
              critical: 'Crítico',
            },
            statusReasons: {
              healthy: 'Estado saludable porque el stage tiene un tiempo promedio de {{averageStageDays}} y sin señales críticas.',
              attention: 'Estado de atención porque el stage tiene un tiempo promedio de {{averageStageDays}} y {{staleCount}} oportunidad(es) detenidas hace más de 7 días.',
              criticalStageTime: 'Estado crítico porque el stage tiene un tiempo promedio de {{averageStageDays}} y {{staleCount}} oportunidad(es) ya están detenidas hace más de 7 días.',
              criticalStaleShare: 'Estado crítico porque {{staleCount}} de {{openCount}} oportunidad(es) abiertas están detenidas hace más de 7 días. Tiempo promedio actual: {{averageStageDays}}.',
            },
            funnel: {
              enteredCount: 'Entraron',
              advancedCount: 'Avanzaron',
              advancementRate: 'Tasa de avance',
              winRate: 'Tasa de ganadas',
              lossRate: 'Tasa de pérdida',
            },
            summary: {
              convertedCount: 'Ganadas',
              convertedAmount: 'Valor ganado',
              createdCount: 'Creadas',
              conversionRate: 'Tasa de conversión',
              lostCount: 'Perdidas',
              lostAmount: 'Valor perdido',
              lossRate: 'Tasa de pérdida',
              openAmount: 'Valor en negociación',
              openCount: 'Oportunidades abiertas',
              averageWonTicket: 'Ticket promedio',
            },
            sources: {
              auto_stage: 'Stage automático',
              manual_button: 'Botón marcar como ganada',
              lost: 'Marcada como perdida',
              other: 'Origen no mapeado ({{key}})',
            },
          },
        },
        groupParticipants: {
          title: 'Gerenciar Grupos',
          subtitle: 'Gestiona los miembros de los grupos de WhatsApp vinculados a tus conexiones.',
          form: {
            whatsapp: 'Conexión de WhatsApp',
            group: 'Grupo',
            groupPlaceholder: 'Selecciona un grupo',
            loadingGroups: 'Cargando grupos...',
            noGroups: 'No hay grupos disponibles para esta conexión.',
            load: 'Cargar participantes',
          },
          placeholder: 'Selecciona una conexión y un grupo para cargar los participantes.',
          emptyState: 'No se encontraron participantes en este grupo.',
          groupIdLabel: 'ID del grupo: {{groupId}}',
          groupSizeLabel: 'Integrantes: {{size}}',
          table: {
            participant: 'Participante',
            number: 'Número',
            admin: 'Rol',
            actions: 'Acciones',
            unknown: 'Nombre desconocido',
            superAdmin: 'Superadministrador',
            adminLabel: 'Administrador',
            member: 'Miembro',
          },
          addParticipants: {
            title: 'Agregar participantes',
            helper:
              'Ingresa un número completo (código de país y área + número) o JID por línea, o selecciona contactos existentes abajo. También puedes separar los valores con comas o punto y coma.',
            placeholder: '5511999999999\n5511888888888@s.whatsapp.net',
            button: 'Agregar al grupo',
            contactsLabel: 'Seleccionar contactos existentes',
            contactsPlaceholder: 'Escribe para buscar contactos',
            contactsNoOptions: 'No se encontraron contactos para esta búsqueda.',
            contactsLoading: 'Cargando contactos...',
          },
          createGroup: {
            title: 'Crear nuevo grupo',
            subtitle: 'Define el asunto y elige los primeros participantes para crear un grupo en la conexión seleccionada.',
            openButton: 'Crear grupo',
            subjectLabel: 'Asunto del grupo',
            subjectPlaceholder: 'Ej.: Equipo de soporte',
            contactsLabel: 'Agregar contactos existentes',
            contactsPlaceholder: 'Escribe para buscar contactos',
            contactsNoOptions: 'No se encontraron contactos para esta búsqueda.',
            contactsLoading: 'Cargando contactos...',
            numbersPlaceholder: '5511999999999\n5511888888888@s.whatsapp.net',
            button: 'Crear grupo',
            cancel: 'Cancelar',
            toasts: {
              missingWhatsapp: 'Seleccione la conexión para crear el grupo.',
              subjectRequired: 'Introduzca un asunto para crear el grupo.',
              noNumbers: 'Añada al menos un número o contacto para continuar.',
              success: 'Grupo creado con éxito.',
            },
          },
          actions: {
            remove: 'Eliminar participante',
            refresh: 'Actualizar lista',
          },
          confirmation: {
            removeParticipant: '¿Deseas eliminar a {{number}} del grupo?',
          },
          toasts: {
            missingInformation: 'Selecciona la conexión y el grupo.',
            loadSuccess: 'Participantes actualizados correctamente.',
            noNumbers: 'Ingresa al menos un número o contacto para continuar.',
            addSuccess: 'Participantes agregados correctamente.',
            removeSuccess: 'Participante eliminado correctamente.',
          },
        },
        messageOptionsMenu: {
          delete: 'Eliminar',
          reply: 'Responder',
          confirmationModal: {
            title: '¿Eliminar mensaje?',
            message: 'Esta acción no se puede deshacer.',
          },
          privateMessage: {
            edit: 'Editar nota',
            delete: 'Eliminar nota',
            confirmationModal: {
              title: '¿Eliminar nota privada?',
              message: 'La nota dejará de aparecer para todo el equipo. Esta acción no se puede deshacer.',
            },
          },
        },
        backendErrors: {
          ERR_PRIVATE_MESSAGE_BODY_REQUIRED: 'Escribe el texto de la nota antes de guardar.',
          ERR_PRIVATE_MESSAGE_ACTION_NOT_ALLOWED: 'Esta acción no está disponible para notas privadas.',
          ERR_NO_MESSAGE_FOUND: 'Mensaje no encontrado.',
          ERR_CRM_STAGE_HAS_OPPORTUNITIES: 'Este stage tiene oportunidades vinculadas y no puede eliminarse.',
          ERR_CRM_STAGE_ORDER_REQUIRED: 'Informe el nuevo orden de los stages.',
          ERR_CRM_STAGE_ORDER_INVALID: 'El orden de stages informado es inválido.',
          ERR_CRM_AUTO_WON_STAGE_ALREADY_EXISTS: 'Ya existe un stage final configurado para este pipeline.',
          ERR_NO_CRM_TAG_FOUND: 'Tag comercial no encontrada.',
          ERR_CRM_TAG_NAME_REQUIRED: 'Ingresa el texto de la tag.',
          ERR_CRM_TAG_ALREADY_EXISTS: 'Ya existe una tag comercial con este texto.',
          ERR_CRM_TAG_IN_USE: 'Esta tag está vinculada a oportunidades y no puede eliminarse.',
          ERR_CRM_TAG_REQUIRED: 'Selecciona una tag.',
          ERR_NO_CRM_PRODUCT_FOUND: 'Producto/servicio no encontrado.',
          ERR_CRM_PRODUCT_NAME_REQUIRED: 'Informa el nombre del producto/servicio.',
          ERR_CRM_PRODUCT_INVALID_PRICE: 'Informa un precio válido.',
          ERR_CRM_PRODUCT_ALREADY_EXISTS: 'Ya existe un producto/servicio con ese nombre.',
          ERR_CRM_PRODUCT_IN_USE: 'Este producto/servicio está vinculado a oportunidades. Desactívalo en lugar de eliminarlo.',
          ERR_CRM_PRODUCT_INACTIVE: 'Este producto/servicio está inactivo.',
          ERR_CRM_TRANSFER_MODE_INVALID: 'Elige copiar o mover la oportunidad.',
          ERR_CRM_TRANSFER_TARGET_REQUIRED: 'Selecciona el pipeline y el stage de destino.',
          ERR_CRM_TRANSFER_SAME_STAGE: 'La oportunidad ya está en ese stage.',
          ERR_NO_OTHER_WHATSAPP: 'Debe haber al menos un WhatsApp predeterminado.',
          ERR_NO_DEF_WAPP_FOUND: 'No se encontró ningún WhatsApp predeterminado. Comprueba la página de conexiones.',
          ERR_WAPP_NOT_INITIALIZED: 'Esta sesión de WhatsApp no se ha inicializado. Comprueba la página de conexiones.',
          ERR_WAPP_CHECK_CONTACT: 'No se pudo verificar el contacto de WhatsApp. Comprueba la página de conexiones',
          ERR_WAPP_INVALID_CONTACT: 'Este no es un número de WhatsApp válido.',
          ERR_WAPP_DOWNLOAD_MEDIA: 'No se pudo descargar medios de WhatsApp. Comprueba la página de conexiones.',
          ERR_WAPP_PAIRING_CODE_NOT_GENERATED: 'No se pudo generar el código de conexión. Espera unos segundos e inténtalo de nuevo.',
          ERR_INVALID_CREDENTIALS: 'Error de autenticación. Por favor, inténtalo de nuevo.',
          ERR_SENDING_WAPP_MSG: 'Error al enviar mensaje de WhatsApp. Comprueba la página de conexiones.',
          ERR_DELETE_WAPP_MSG: 'No se pudo eliminar el mensaje de WhatsApp.',
          ERR_OTHER_OPEN_TICKET: 'Ya hay un ticket abierto para este contacto.',
          ERR_OTHER_OPEN_TICKET_DETAILS: 'Fila {{queue}} • Usuario {{user}}.',
          ERR_SESSION_EXPIRED: 'Sesión expirada. Por favor, inicia sesión.',
          ERR_USER_CREATION_DISABLED: 'La creación de usuarios ha sido deshabilitada por el administrador.',
          ERR_NO_PERMISSION: 'No tienes permiso para acceder a este recurso.',
          NO_PARTICIPANT_NUMBERS: 'No se proporcionó ningún participante.',
          NO_VALID_PARTICIPANTS: 'Ninguno de los valores enviados pudo interpretarse como participante.',
          ERR_ADD_GROUP_PARTICIPANT: 'Error al agregar participantes al grupo.',
          ERR_REMOVE_GROUP_PARTICIPANT: 'Error al eliminar participantes del grupo.',
          ERR_DUPLICATED_CONTACT: 'Ya existe un contacto con este número.',
          ERR_NO_SETTING_FOUND: 'No se encontró ninguna configuración con esta ID.',
          ERR_NO_CONTACT_FOUND: 'No se encontró ningún contacto con esta ID.',
          ERR_CANNOT_BLOCK_GROUP_CONTACT: 'No es posible bloquear un grupo.',
          ERR_NO_TICKET_FOUND: 'No se encontró ningún ticket con esta ID.',
          ERR_NO_USER_FOUND: 'No se encontró ningún usuario con esta ID.',
          ERR_NO_WAPP_FOUND: 'No se encontró ningún WhatsApp con esta ID.',
          ERR_USER_WHATSAPP_NOT_ALLOWED: 'No tiene acceso a esta conexión.',
          ERR_USER_DEFAULT_WHATSAPP_NOT_ALLOWED: 'La conexión predeterminada debe estar entre las conexiones permitidas.',
          ERR_CREATING_MESSAGE: 'Error al crear mensaje en la base de datos.',
          ERR_CREATING_TICKET: 'Error al crear ticket en la base de datos.',
          ERR_FETCH_WAPP_MSG: 'Error al obtener mensaje de WhatsApp, puede que sea muy antiguo.',
          ERR_QUEUE_COLOR_ALREADY_EXISTS: 'Este color ya está en uso, elige otro.',
          ERR_WAPP_GREETING_REQUIRED: 'El saludo es obligatorio cuando hay más de una cola.',
          ERR_WAPP_AGENT_TEST_REQUIRES_QUEUE: 'Cuando el agente de la conexión está en modo de prueba, la conexión debe tener al menos una cola para el flujo normal del chatbot.',
          ERR_COMPANY_DOCUMENT_ALREADY_EXISTS: 'Ya existe una empresa registrada con estos datos. Por favor, verifica la información proporcionada.',
          ERR_COMPANY_EMAIL_ALREADY_EXISTS: 'Este correo ya está en uso. Inicia sesión o recupera tu contraseña.',
          ERR_WEAK_PASSWORD: 'Usa 8 caracteres o más, con mayúscula, minúscula y número.',
          ERR_INVALID_RESET_TOKEN: 'Código inválido o vencido. Revisa el código o pide uno nuevo.',
          ERR_TOO_MANY_REQUESTS: 'Demasiados intentos. Espera unos minutos e inténtalo de nuevo.',
          ERR_SIGNUP_DISABLED: 'Los registros nuevos están cerrados en este momento.',
          ERR_TERMS_NOT_ACCEPTED: 'Acepta los términos para crear la cuenta.',
          ERR_PLAN_NOT_AVAILABLE: 'Este plan no está disponible para registrarse. Elige otro.',
          ERR_QUICKMESSAGE_NAME_ALREADY_EXISTS: 'Ya existe una respuesta rápida con este nombre.',
        },
        companyExpiredModal: {
          title: 'Empresa Expirada',
          message: 'Regulariza los pagos para volver a utilizar el sistema.',
        },
      },
    },
  },
}

export { messages }
